import React from "react";

export const ExpandMoreIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
    {...props}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M7 10l5 5 5-5z" />
  </svg>
);

export const ExpandLessIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
    {...props}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M7 14l5-5 5 5z" />
  </svg>
);

export const DeleteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="18"
    height="18"
    fill="currentColor"
    {...props}
  >
    <path d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z" />
  </svg>
);

export const PencilIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="currentColor"
    {...props}
  >
    <path d="M21.707 5.293l-3-3a1 1 0 0 0-1.414 0l-13 13a1 1 0 0 0-.271.521l-1 5a1 1 0 0 0 .271.792A1 1 0 0 0 4 22a1 1 0 0 0 .208-.021l5-1a1 1 0 0 0 .521-.271l13-13a1 1 0 0 0 0-1.414zM8.208 19.207l-3.041.607.607-3.041L16.586 6.059 18 7.473zM19 6.473L17.586 5.059 18.793 3.852 20.207 5.266z" />
  </svg>
);

export const ChatSendIcon = (props) => (
  <svg
    className="insyncSendIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 28.589 28.591"
  >
    <circle
      cx="14.295"
      cy="14.295"
      r="14.295"
      fill={props.userSendIconCircleFillColor}
    />
    <g id="Arrow" transform="translate(0 -0.028)">
      <path
        id="Path"
        d="M1.165,13.131A1.177,1.177,0,0,0,0,14.3,15.3,15.3,0,0,0,.192,16.6a14.021,14.021,0,0,0,1.333,4.119A14.267,14.267,0,0,0,15.835,28.5a14.921,14.921,0,0,0,2.291-.431,15.028,15.028,0,0,0,2.16-.8,14.152,14.152,0,0,0,3.549-2.332,14.245,14.245,0,0,0,4.713-11.683,14.062,14.062,0,0,0-.984-4.265,14.938,14.938,0,0,0-1-2.032,15.144,15.144,0,0,0-1.307-1.828A14.274,14.274,0,0,0,18.2.54a14.375,14.375,0,0,0-8.74.3,14.179,14.179,0,0,0-3.75,2.032,15.022,15.022,0,0,0-1.7,1.491A15.312,15.312,0,0,0,2.591,6.094,14.17,14.17,0,0,0,.684,9.92,14.315,14.315,0,0,0,0,14.3,1.187,1.187,0,0,0,1.165,15.46,1.177,1.177,0,0,0,2.329,14.3a13.49,13.49,0,0,1,.119-1.779c-.012.1-.026.207-.041.309A13.154,13.154,0,0,1,3.316,9.5c-.038.093-.079.186-.116.279A13.287,13.287,0,0,1,4.9,6.872l-.183.236A13.3,13.3,0,0,1,7.106,4.714L6.871,4.9A13.287,13.287,0,0,1,9.779,3.2L9.5,3.317a13.344,13.344,0,0,1,3.325-.908c-.1.012-.207.026-.309.041a13.477,13.477,0,0,1,3.558,0c-.1-.012-.207-.026-.309-.041a13.154,13.154,0,0,1,3.325.908L18.81,3.2a13.287,13.287,0,0,1,2.908,1.7l-.236-.183a13.3,13.3,0,0,1,2.393,2.393l-.183-.236a13.287,13.287,0,0,1,1.7,2.908c-.038-.093-.079-.186-.116-.279a13.344,13.344,0,0,1,.908,3.325c-.012-.1-.026-.207-.041-.309a13.477,13.477,0,0,1,0,3.558c.012-.1.026-.207.041-.309a13.154,13.154,0,0,1-.908,3.325c.038-.093.079-.186.116-.279a13.287,13.287,0,0,1-1.7,2.908l.183-.236a13.3,13.3,0,0,1-2.393,2.393l.236-.183a13.287,13.287,0,0,1-2.908,1.7l.279-.116a13.344,13.344,0,0,1-3.325.908c.1-.012.207-.026.309-.041a13.477,13.477,0,0,1-3.558,0c.1.012.207.026.309.041A13.154,13.154,0,0,1,9.5,25.274l.279.116a13.287,13.287,0,0,1-2.908-1.7l.236.183a13.3,13.3,0,0,1-2.393-2.393l.183.236a13.287,13.287,0,0,1-1.7-2.908c.038.093.079.186.116.279a13.344,13.344,0,0,1-.908-3.325c.012.1.026.207.041.309A13.49,13.49,0,0,1,2.329,14.3,1.185,1.185,0,0,0,1.165,13.131Z"
        transform="translate(0 0.028)"
        fill={props.userSendIconCircleBorderColor}
      />
      <path
        id="Path-2"
        data-name="Path"
        d="M1.166,0A1.185,1.185,0,0,0,0,1.168,1.177,1.177,0,0,0,1.166,2.333h.02c.489.009.975,0,1.464,0H13.178a1.185,1.185,0,0,0,1.165-1.165A1.177,1.177,0,0,0,13.178,0h-.02c-.489-.009-.975,0-1.464,0H1.166Z"
        transform="translate(7.068 13.243)"
        fill={props.userSendIconArrowColor}
      />
      <path
        id="Path-3"
        data-name="Path"
        d="M.342,10.882A1.186,1.186,0,0,0,0,11.706a1.166,1.166,0,0,0,.341.824,1.2,1.2,0,0,0,.824.341,1.223,1.223,0,0,0,.824-.341l.693-.64L5.7,9.1q.948-.878,1.9-1.758a1.177,1.177,0,0,0,0-1.648c-.23-.218-.463-.44-.693-.661L3.893,2.154Q2.941,1.242,1.986.332a1.189,1.189,0,0,0-1.648,0,1.175,1.175,0,0,0,0,1.648c.23.218.463.44.693.661L4.045,5.52Q5,6.433,5.952,7.342V5.695l-.693.64L2.243,9.124Q1.3,10,.342,10.882Z"
        transform="translate(13.577 7.895)"
        fill={props.userSendIconArrowColor}
      />
    </g>
  </svg>
);

export const StudentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 148 136"
    {...props}
  >
    <path
      d="M0 0 C48.84 0 97.68 0 148 0 C148 44.88 148 89.76 148 136 C99.16 136 50.32 136 0 136 C0 91.12 0 46.24 0 0 Z"
      fill="#FBFCFE"
    />
    <path
      d="M0 0 C2.49315468 2.34904169 3.67571808 4.60924865 5.2265625 7.7109375 C5.2265625 12.6609375 5.2265625 17.6109375 5.2265625 22.7109375 C-25.1334375 22.7109375 -55.4934375 22.7109375 -86.7734375 22.7109375 C-86.7734375 6.12571023 -86.7734375 6.12571023 -83.3984375 2.05078125 C-63.20091318 -15.37929383 -21.51930061 -15.64178238 0 0 Z"
      fill="#B9B9B9"
      transform="translate(120.7734375,93.2890625)"
    />
    <path
      d="M0 0 C15.61822058 -0.79803245 29.68308714 0.47053146 42.62011719 10.13525391 C44.62011719 13.13525391 44.62011719 13.13525391 44.62011719 19.13525391 C18.55011719 19.13525391 -7.51988281 19.13525391 -34.37988281 19.13525391 C-34.37988281 11.13525391 -34.37988281 11.13525391 -32.50488281 8.88525391 C-28.27585483 6.51699824 -23.92600586 4.79576963 -19.37988281 3.13525391 C-18.41050781 2.74337891 -17.44113281 2.35150391 -16.44238281 1.94775391 C-10.99349335 0.50213017 -5.61106971 0.31888927 0 0 Z"
      fill="#FDFDFD"
      transform="translate(75.3798828125,89.86474609375)"
    />
    <path
      d="M0 0 C9.58031853 9.34081056 9.58031853 9.34081056 9.8125 17.125 C9.72241099 23.31411524 8.04636724 27.66787307 3.8515625 32.23046875 C0.6008686 35.21855201 -1.96943728 37.22175892 -6.5 37.4375 C-7.16902344 37.49808594 -7.83804688 37.55867188 -8.52734375 37.62109375 C-14.30304279 37.94690241 -18.90063649 37.08993573 -23.5 33.4375 C-28.23714613 27.73232836 -31.00376171 22.398086 -30.90625 14.9140625 C-29.94987115 9.08382987 -25.79545517 4.25511854 -21.5 0.375 C-15.39091633 -3.56105391 -6.36603746 -2.84198101 0 0 Z"
      fill="#B9B9B9"
      transform="translate(90.5,30.5625)"
    />
    <path
      d="M0 0 C3.17619926 2.04688397 4.91655946 3.53106445 6.8125 6.8125 C7.81656074 13.00002432 6.41325703 17.56143542 2.8125 22.625 C-1.45944062 25.7399567 -5.06104675 25.58949127 -10.1875 24.8125 C-13.95042473 23.21125543 -16.02847382 21.26694189 -18.1875 17.8125 C-19.39393566 14.19319302 -19.51018559 11.62018995 -19.1875 7.8125 C-14.92181822 -0.40288713 -8.89415944 -3.31351038 0 0 Z"
      fill="#FDFDFD"
      transform="translate(86.1875,36.1875)"
    />
  </svg>
);

export const UniversityIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 114 82"
    {...props}
  >
    <path
      d="M0 0 C37.62 0 75.24 0 114 0 C114 27.06 114 54.12 114 82 C76.38 82 38.76 82 0 82 C0 54.94 0 27.88 0 0 Z"
      fill="#FEFEFE"
      transform="translate(0,0)"
    />
    <path
      d="M0 0 C1.99573772 0.93126385 3.95901869 1.93365498 5.89453125 2.984375 C7.01537109 3.59023437 8.13621094 4.19609375 9.29101562 4.8203125 C10.15980347 5.29645996 10.15980347 5.29645996 11.04614258 5.78222656 C12.79321437 6.73943355 14.54600022 7.68618723 16.29882812 8.6328125 C18.53876692 9.84969615 20.76796864 11.08659486 22.98486328 12.3449707 C25.88118389 14.00392981 25.88118389 14.00392981 28.58935547 15.08276367 C30.98235321 16.17639493 32.37156305 16.92455843 34 19 C34.96883315 23.64091677 34.75362149 28.09855436 34.5 32.8125 C34.46390625 34.07771484 34.4278125 35.34292969 34.390625 36.64648438 C34.29640876 39.76739744 34.16498197 42.88215808 34 46 C32.68 46 31.36 46 30 46 C30 38.08 30 30.16 30 22 C28.02 22.99 26.04 23.98 24 25 C23.34 25 22.68 25 22 25 C22 31.93 22 38.86 22 46 C18.30267085 48.20821036 14.59410389 50.39152912 10.875 52.5625 C9.82828125 53.19091797 8.7815625 53.81933594 7.703125 54.46679688 C6.17558594 55.35141602 6.17558594 55.35141602 4.6171875 56.25390625 C3.21895752 57.07870483 3.21895752 57.07870483 1.79248047 57.92016602 C-1.66962241 59.25893862 -3.45124518 58.99128376 -7 58 C-9.5012207 56.89257812 -9.5012207 56.89257812 -11.92578125 55.53125 C-12.80427734 55.04269531 -13.68277344 54.55414063 -14.58789062 54.05078125 C-15.93657227 53.28314453 -15.93657227 53.28314453 -17.3125 52.5 C-18.69018555 51.73236328 -18.69018555 51.73236328 -20.09570312 50.94921875 C-26.81540179 47.18459821 -26.81540179 47.18459821 -28 46 C-28.08685603 44.43827255 -28.10702219 42.87270656 -28.09765625 41.30859375 C-28.09443359 40.36435547 -28.09121094 39.42011719 -28.08789062 38.44726562 C-28.07951172 37.45404297 -28.07113281 36.46082031 -28.0625 35.4375 C-28.05798828 34.44041016 -28.05347656 33.44332031 -28.04882812 32.41601562 C-28.03700007 29.94395151 -28.02051849 27.47200482 -28 25 C-28.92039062 24.70351563 -29.84078125 24.40703125 -30.7890625 24.1015625 C-34.03380256 22.9884035 -36.96477488 21.58987983 -40 20 C-40 19.34 -40 18.68 -40 18 C-39.50822266 17.74420166 -39.01644531 17.48840332 -38.50976562 17.22485352 C-36.17177293 16.00674196 -33.8357815 14.7848462 -31.5 13.5625 C-30.64519043 13.11672607 -29.79038086 12.67095215 -28.90966797 12.21166992 C-24.67224666 9.98778897 -20.4756741 7.72534019 -16.3515625 5.296875 C-15.63677734 4.87849365 -14.92199219 4.4601123 -14.18554688 4.02905273 C-12.83832059 3.23364651 -11.49806105 2.42628873 -10.16601562 1.60571289 C-6.22125899 -0.71574508 -4.35590839 -1.27931579 0 0 Z"
      fill="#B9B9B9"
      transform="translate(56,5)"
    />
    <path
      d="M0 0 C1.8683095 0.84740512 3.70742121 1.76092187 5.51953125 2.72265625 C6.54111328 3.26083984 7.56269531 3.79902344 8.61523438 4.35351562 C10.19788086 5.19946289 10.19788086 5.19946289 11.8125 6.0625 C12.88693359 6.63033203 13.96136719 7.19816406 15.06835938 7.78320312 C17.71530675 9.18314418 20.35898899 10.58890112 23 12 C23 13.32 23 14.64 23 16 C19.2763007 17.98958197 15.54516937 19.96480551 11.8125 21.9375 C10.75740234 22.50146484 9.70230469 23.06542969 8.61523438 23.64648438 C7.59365234 24.18466797 6.57207031 24.72285156 5.51953125 25.27734375 C4.58214111 25.77484131 3.64475098 26.27233887 2.67895508 26.78491211 C-0.04366162 28.0198035 -2.01280497 28.83009037 -5 29 C-7.9543457 27.82836914 -7.9543457 27.82836914 -11.17578125 26.03515625 C-12.33271484 25.40029297 -13.48964844 24.76542969 -14.68164062 24.11132812 C-15.89210084 23.42869344 -17.10238514 22.74574673 -18.3125 22.0625 C-19.54159297 21.38215261 -20.7714041 20.70310089 -22.00195312 20.02539062 C-25.00861706 18.36288233 -28.00728912 16.68745702 -31 15 C-31 14.34 -31 13.68 -31 13 C-27.3987932 10.9694391 -23.78761457 8.95804122 -20.16625977 6.96362305 C-18.93650276 6.28290808 -17.70956431 5.5970746 -16.4855957 4.90600586 C-14.72320621 3.91211264 -12.94958808 2.93821407 -11.17578125 1.96484375 C-10.11270752 1.3730835 -9.04963379 0.78132324 -7.9543457 0.17163086 C-4.59139103 -1.16204565 -3.37158279 -1.17295732 0 0 Z"
      fill="#FDFDFD"
      transform="translate(56,10)"
    />
    <path
      d="M0 0 C2.60540782 1.28921216 5.20934373 2.58125596 7.8125 3.875 C8.55048828 4.23980469 9.28847656 4.60460938 10.04882812 4.98046875 C10.76103516 5.33496094 11.47324219 5.68945312 12.20703125 6.0546875 C12.8616333 6.37937012 13.51623535 6.70405273 14.19067383 7.03857422 C16 8 16 8 19 10 C23.97669732 9.79449903 28.01194546 6.9050449 32.1875 4.4375 C33.61626872 3.59906849 35.0471626 2.76424466 36.48046875 1.93359375 C37.42249146 1.3775647 37.42249146 1.3775647 38.38354492 0.81030273 C40 0 40 0 42 0 C42 5.28 42 10.56 42 16 C38.89727579 17.64860274 35.79291675 19.29398341 32.6875 20.9375 C31.80642578 21.40607422 30.92535156 21.87464844 30.01757812 22.35742188 C28.74624023 23.0293457 28.74624023 23.0293457 27.44921875 23.71484375 C26.66893311 24.12855225 25.88864746 24.54226074 25.0847168 24.96850586 C23 26 23 26 20 27 C17.82348633 26.10375977 17.82348633 26.10375977 15.33203125 24.69140625 C14.43935547 24.19189453 13.54667969 23.69238281 12.62695312 23.17773438 C11.23379883 22.37819336 11.23379883 22.37819336 9.8125 21.5625 C8.87212891 21.03333984 7.93175781 20.50417969 6.96289062 19.95898438 C4.63681573 18.64835334 2.31773275 17.32532751 0 16 C0 10.72 0 5.44 0 0 Z"
      fill="#FDFDFD"
      transform="translate(32,33)"
    />
  </svg>
);

export const MemoryIcon = ({ style }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={style?.width || "60"}
    height={style?.height || "62"}
    viewBox="0 0 60 62"
    style={style}
  >
    <path
      d="M0 0 C19.8 0 39.6 0 60 0 C60 20.46 60 40.92 60 62 C40.2 62 20.4 62 0 62 C0 41.54 0 21.08 0 0 Z "
      fill="#FEFEFE"
      transform="translate(0,0)"
    />
    <path
      d="M0 0 C3.70780441 3.70780441 2.453175 10.06752637 2.48046875 15.12084961 C2.49984428 17.29502655 2.56184175 19.46538678 2.625 21.63867188 C2.63806521 23.02601925 2.64856416 24.41339364 2.65625 25.80078125 C2.68428711 27.69050659 2.68428711 27.69050659 2.71289062 29.6184082 C1.7185052 34.33526866 -0.07599612 35.31942009 -4 38 C-12.75463162 41.99777976 -25.41539235 41.24563342 -34.25 38.1875 C-37.49241285 36.9052731 -39.88621868 35.80551709 -42 33 C-42.40405273 29.96899414 -42.40405273 29.96899414 -42.43359375 26.28515625 C-42.4388356 25.63300644 -42.44407745 24.98085663 -42.44947815 24.3089447 C-42.45589347 22.93131939 -42.45456757 21.55363927 -42.44604492 20.17602539 C-42.43754137 18.07273299 -42.46628361 15.97216417 -42.49804688 13.86914062 C-42.49965929 12.52864664 -42.49908059 11.18814787 -42.49609375 9.84765625 C-42.49794678 8.63086182 -42.4997998 7.41406738 -42.50170898 6.16040039 C-41.9074205 2.41681671 -40.95001488 1.29354898 -38 -1 C-27.34050913 -6.32974543 -10.26959847 -6.15726473 0 0 Z "
      fill="#BCBCBC"
      transform="translate(51,12)"
    />
    <path
      d="M0 0 C0.81082031 0.2165625 1.62164062 0.433125 2.45703125 0.65625 C15.20530843 3.86187034 25.398351 3.18629394 38 0 C38.10824843 1.6026782 38.18570645 3.20745748 38.25 4.8125 C38.29640625 5.70582031 38.3428125 6.59914063 38.390625 7.51953125 C38 10 38 10 36.421875 11.69921875 C30.88128172 14.67505353 25.32920571 15.36184654 19.125 15.3125 C18.07771729 15.30839111 18.07771729 15.30839111 17.00927734 15.30419922 C10.80184087 15.17881102 4.57945009 14.57945009 0 10 C-0.1953125 7.6171875 -0.1953125 7.6171875 -0.125 4.875 C-0.10695313 3.96492188 -0.08890625 3.05484375 -0.0703125 2.1171875 C-0.04710937 1.41851562 -0.02390625 0.71984375 0 0 Z "
      fill="#FCFCFC"
      transform="translate(12,34)"
    />
    <path
      d="M0 0 C0.6084375 0.2165625 1.216875 0.433125 1.84375 0.65625 C14.06615679 4.53866157 25.89942354 4.03352549 38 0 C38 3.63 38 7.26 38 11 C26.91178466 16.0005677 14.73751253 16.67080508 3 13 C2.01 12.34 1.02 11.68 0 11 C-0.29296875 8.3984375 -0.29296875 8.3984375 -0.1875 5.375 C-0.16042969 4.37210938 -0.13335937 3.36921875 -0.10546875 2.3359375 C-0.07066406 1.56507812 -0.03585937 0.79421875 0 0 Z "
      fill="#FDFDFD"
      transform="translate(12,20)"
    />
    <path
      d="M0 0 C0.81210937 -0.01611328 1.62421875 -0.03222656 2.4609375 -0.04882812 C8.94976632 -0.05402751 13.79819558 1.39909779 19.625 4.3125 C19.625 4.9725 19.625 5.6325 19.625 6.3125 C10.18296946 11.39667029 -0.80745164 11.81666081 -11.1875 9.4375 C-14.375 8.3125 -14.375 8.3125 -17.375 6.3125 C-16.75 4.4375 -16.75 4.4375 -15.375 2.3125 C-10.27349065 0.04073412 -5.47662573 -0.02152762 0 0 Z "
      fill="#FCFCFC"
      transform="translate(30.375,10.6875)"
    />
    <path
      d="M0 0 C2.75150737 0.08711104 5.49981633 0.19399615 8.25 0.3125 C9.02730469 0.33505859 9.80460937 0.35761719 10.60546875 0.38085938 C14.93979093 0.58460956 17.78041105 0.77175624 21 4 C18.43721301 4.05420701 15.87558517 4.09377007 13.3125 4.125 C12.59126953 4.14175781 11.87003906 4.15851562 11.12695312 4.17578125 C6.95123219 4.21391569 3.7505862 3.8789919 0 2 C0 1.34 0 0.68 0 0 Z "
      fill="#C5C5C5"
      transform="translate(18,20)"
    />
    <path
      d="M0 0 C0 0.66 0 1.32 0 2 C-3.06533164 3.53266582 -6.26754272 3.10276471 -9.625 3.0625 C-10.33140625 3.05798828 -11.0378125 3.05347656 -11.765625 3.04882812 C-13.51045275 3.03703875 -15.255237 3.01910324 -17 3 C-17 2.67 -17 2.34 -17 2 C-14.91727106 1.66291092 -12.83378963 1.33046884 -10.75 1 C-9.58984375 0.814375 -8.4296875 0.62875 -7.234375 0.4375 C-4 0 -4 0 0 0 Z "
      fill="#B6B6B6"
      transform="translate(44,20)"
    />
  </svg>
);

export const DataStoreIcon = ({ style }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 108 108"
      style={style}
    >
      <path
        d="M0 0 C35.64 0 71.28 0 108 0 C108 35.64 108 71.28 108 108 C72.36 108 36.72 108 0 108 C0 72.36 0 36.72 0 0 Z "
        fill="#FEFEFE"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C2.96826923 2.59807692 2.96826923 2.59807692 3.1875 5.375 C1.30152156 9.54400497 -1.96015079 11.0825593 -6 13 C-21.10415721 18.61475583 -40.75718876 19.78908162 -56 14 C-57.32 13.34 -58.64 12.68 -60 12 C-60 17.28 -60 22.56 -60 28 C-51.41174671 32.02574373 -43.32859733 33.1203804 -34 34 C-34.33 35.65 -34.66 37.3 -35 39 C-44.05023404 38.70805697 -51.5118086 37.17028835 -60 34 C-60 38.95 -60 43.9 -60 49 C-51.77061938 54.25279614 -43.60918424 55.23768476 -34 56 C-33.34 57.65 -32.68 59.3 -32 61 C-44.24310399 60.69277029 -55.84402626 60.15597374 -65 51 C-66.16166373 48.67667254 -66.16304629 47.23489862 -66.22460938 44.64550781 C-66.24712769 43.74407043 -66.269646 42.84263306 -66.29284668 41.91387939 C-66.36384235 37.78446813 -66.42137587 33.65523747 -66.45996094 29.52539062 C-66.48656884 27.34873451 -66.52749478 25.17220453 -66.58300781 22.99609375 C-66.66217148 19.85625302 -66.69527405 16.71881762 -66.71875 13.578125 C-66.75174194 12.60917297 -66.78473389 11.64022095 -66.81872559 10.64190674 C-66.79923026 4.0395385 -66.79923026 4.0395385 -64.50941467 1.06123352 C-60.8143753 -2.20608739 -57.23021773 -4.00329792 -52.4375 -5.3125 C-51.36371094 -5.61800781 -50.28992188 -5.92351563 -49.18359375 -6.23828125 C-33.65410547 -9.95392569 -13.34517579 -9.85859833 0 0 Z "
        fill="#BCBCBC"
        transform="translate(80,24)"
      />
      <path
        d="M0 0 C3.14547466 2.59386741 5.39262147 4.90359921 6.93359375 8.73046875 C7.28510624 14.26679052 7.06594484 16.39959104 4.93359375 21.73046875 C8.23359375 25.03046875 11.53359375 28.33046875 14.93359375 31.73046875 C14.27359375 33.05046875 13.61359375 34.37046875 12.93359375 35.73046875 C12.49789062 35.34375 12.0621875 34.95703125 11.61328125 34.55859375 C9.74154558 32.92183788 7.84624093 31.31919988 5.93359375 29.73046875 C5.39734375 29.281875 4.86109375 28.83328125 4.30859375 28.37109375 C2.65683277 27.04860761 2.65683277 27.04860761 -0.06640625 25.73046875 C-2.46725087 26.54018891 -2.46725087 26.54018891 -5.06640625 27.73046875 C-9.78502629 27.95850615 -13.74896533 27.3998336 -17.50390625 24.41796875 C-22.01893762 19.68269195 -22.62748299 15.93223039 -22.515625 9.49609375 C-21.78605382 5.00447294 -19.54514545 2.51845352 -16.06640625 -0.26953125 C-11.24145512 -3.39922928 -4.84632356 -2.97741996 0 0 Z "
        fill="#BBBBBB"
        transform="translate(76.06640625,57.26953125)"
      />
      <path
        d="M0 0 C2.39453125 1.63671875 2.39453125 1.63671875 4 3 C3 6 3 6 0.84765625 7.09765625 C-15.99043015 12.93076613 -33.09100265 14.76812611 -50 8 C-51.69079014 7.04135174 -53.36671253 6.05363647 -55 5 C-53.97064581 2.11175323 -53.33090762 1.16545381 -50.5390625 -0.23046875 C-49.57742187 -0.54628906 -48.61578125 -0.86210937 -47.625 -1.1875 C-46.19027344 -1.67283203 -46.19027344 -1.67283203 -44.7265625 -2.16796875 C-30.79899472 -6.41807181 -13.49447027 -5.50456563 0 0 Z "
        fill="#FDFDFD"
        transform="translate(74,25)"
      />
      <path
        d="M0 0 C2.99559257 1.29011865 3.81502626 2.32340716 6 5 C6.73994373 8.14760681 6.68576465 10.84548261 6 14 C4.20606332 16.87029869 3.01736724 18.49131638 0 20 C-7.08958838 20.5811138 -7.08958838 20.5811138 -10.9375 18.125 C-14.09695358 14.8698054 -14.33421243 12.57586762 -14.29296875 8.0390625 C-13.83745033 4.86865433 -12.24684343 3.1807598 -10 1 C-6.75514188 -0.62242906 -3.5066405 -0.55197119 0 0 Z "
        fill="#FDFDFD"
        transform="translate(72,60)"
      />
    </svg>
  );
};

export const AgentIcon = ({ style }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 78 100"
      style={style}
    >
      <path
        d="M0 0 C25.74 0 51.48 0 78 0 C78 33 78 66 78 100 C52.26 100 26.52 100 0 100 C0 67 0 34 0 0 Z "
        fill="#FEFEFE"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C1.37315214 -0.01146716 2.74626157 -0.03183513 4.11914062 -0.06152344 C12.84627795 -0.2500532 21.1931117 -0.42775138 28.02319336 5.70776367 C31.62330255 9.7296349 33.27100999 13.35469107 33.76318359 18.67016602 C33.29233985 24.13195343 31.66157637 27.85518542 28.13818359 32.04516602 C22.88719918 36.44133901 18.67456814 37.67603229 11.85693359 37.69360352 C10.79230896 37.69790878 10.79230896 37.69790878 9.70617676 37.70230103 C8.21361487 37.70433197 6.72102578 37.69887023 5.22851562 37.6862793 C2.95690838 37.67021005 0.68707992 37.68615927 -1.58447266 37.70532227 C-3.04150779 37.70333966 -4.49854183 37.69949562 -5.95556641 37.69360352 C-7.92493164 37.68852783 -7.92493164 37.68852783 -9.93408203 37.68334961 C-15.39856396 37.09660418 -19.34039871 35.12429801 -22.79931641 30.85766602 C-23.51861328 29.99334961 -23.51861328 29.99334961 -24.25244141 29.11157227 C-27.43712888 24.65109132 -28.32445413 20.76088075 -27.54931641 15.29516602 C-25.57552354 8.62424584 -21.43038522 4.78516373 -15.54931641 1.29516602 C-10.52013476 -0.38122787 -5.26716084 0.03057224 0 0 Z "
        fill="#FDFDFD"
        transform="translate(35.54931640625,13.704833984375)"
      />
      <path
        d="M0 0 C1.04788696 -0.01260864 2.09577393 -0.02521729 3.17541504 -0.03820801 C4.86459045 -0.02606262 4.86459045 -0.02606262 6.58789062 -0.01367188 C8.32975647 -0.01941223 8.32975647 -0.01941223 10.10681152 -0.02526855 C12.56128812 -0.0279898 15.01579361 -0.02061392 17.47021484 -0.00390625 C21.23014904 0.01749847 24.98817222 -0.00370276 28.74804688 -0.02929688 C31.13216568 -0.02665364 33.5162833 -0.02152875 35.90039062 -0.01367188 C37.02650757 -0.0217688 38.15262451 -0.02986572 39.31286621 -0.03820801 C40.36075317 -0.02559937 41.40864014 -0.01299072 42.48828125 0 C43.86916931 0.00477356 43.86916931 0.00477356 45.2779541 0.00964355 C47.74414062 0.51757812 47.74414062 0.51757812 51.74414062 4.51757812 C51.74414062 11.11757812 51.74414062 17.71757813 51.74414062 24.51757812 C31.61414062 24.51757812 11.48414062 24.51757812 -9.25585938 24.51757812 C-9.25585938 0.03199636 -9.25585938 0.03199636 0 0 Z "
        fill="#FCFCFC"
        transform="translate(17.255859375,58.482421875)"
      />
      <path
        d="M0 0 C1.37315214 -0.01146716 2.74626157 -0.03183513 4.11914062 -0.06152344 C12.84627795 -0.2500532 21.1931117 -0.42775138 28.02319336 5.70776367 C31.62330255 9.7296349 33.27100999 13.35469107 33.76318359 18.67016602 C33.29233985 24.13195343 31.66157637 27.85518542 28.13818359 32.04516602 C22.88719918 36.44133901 18.67456814 37.67603229 11.85693359 37.69360352 C10.79230896 37.69790878 10.79230896 37.69790878 9.70617676 37.70230103 C8.21361487 37.70433197 6.72102578 37.69887023 5.22851562 37.6862793 C2.95690838 37.67021005 0.68707992 37.68615927 -1.58447266 37.70532227 C-3.04150779 37.70333966 -4.49854183 37.69949562 -5.95556641 37.69360352 C-7.92493164 37.68852783 -7.92493164 37.68852783 -9.93408203 37.68334961 C-15.39856396 37.09660418 -19.34039871 35.12429801 -22.79931641 30.85766602 C-23.51861328 29.99334961 -23.51861328 29.99334961 -24.25244141 29.11157227 C-27.43712888 24.65109132 -28.32445413 20.76088075 -27.54931641 15.29516602 C-25.57552354 8.62424584 -21.43038522 4.78516373 -15.54931641 1.29516602 C-10.52013476 -0.38122787 -5.26716084 0.03057224 0 0 Z M-21.42431641 11.48266602 C-23.49065772 16.6485193 -23.19742301 21.38685213 -21.42431641 26.60766602 C-19.12430099 29.90435478 -17.06542595 31.34177183 -13.54931641 33.29516602 C-9.88636407 33.90462611 -9.88636407 33.90462611 -5.95556641 33.82641602 C-5.24581665 33.83024292 -4.53606689 33.83406982 -3.80480957 33.8380127 C-2.31224133 33.84072064 -0.81962472 33.83343792 0.67285156 33.81665039 C2.94493372 33.79522025 5.21385489 33.81648549 7.48583984 33.84204102 C8.942878 33.83939754 10.39991421 33.83427213 11.85693359 33.82641602 C13.16984375 33.8219043 14.48275391 33.81739258 15.83544922 33.81274414 C20.02944924 33.21230654 22.17828996 31.9387183 25.45068359 29.29516602 C28.74867475 24.56804535 29.35447588 19.89867818 28.45068359 14.29516602 C26.1970375 9.78787383 23.95595394 7.46970776 19.45068359 5.29516602 C14.74529529 4.75222398 10.03618529 4.82214377 5.30395508 4.84912109 C3.02316957 4.85762877 0.74489377 4.82885136 -1.53564453 4.79711914 C-2.99723233 4.79550669 -4.45882452 4.79608549 -5.92041016 4.79907227 C-7.23968506 4.79721924 -8.55895996 4.79536621 -9.91821289 4.79345703 C-14.99927324 5.49550632 -18.11617896 7.62317233 -21.42431641 11.48266602 Z "
        fill="#BBBBBB"
        transform="translate(35.54931640625,13.704833984375)"
      />
      <path
        d="M0 0 C1.04788696 -0.01260864 2.09577393 -0.02521729 3.17541504 -0.03820801 C4.86459045 -0.02606262 4.86459045 -0.02606262 6.58789062 -0.01367188 C8.32975647 -0.01941223 8.32975647 -0.01941223 10.10681152 -0.02526855 C12.56128812 -0.0279898 15.01579361 -0.02061392 17.47021484 -0.00390625 C21.23014904 0.01749847 24.98817222 -0.00370276 28.74804688 -0.02929688 C31.13216568 -0.02665364 33.5162833 -0.02152875 35.90039062 -0.01367188 C37.02650757 -0.0217688 38.15262451 -0.02986572 39.31286621 -0.03820801 C40.36075317 -0.02559937 41.40864014 -0.01299072 42.48828125 0 C43.86916931 0.00477356 43.86916931 0.00477356 45.2779541 0.00964355 C47.74414062 0.51757812 47.74414062 0.51757812 51.74414062 4.51757812 C51.74414062 11.11757812 51.74414062 17.71757813 51.74414062 24.51757812 C31.61414062 24.51757812 11.48414062 24.51757812 -9.25585938 24.51757812 C-9.25585938 0.03199636 -9.25585938 0.03199636 0 0 Z M-4.25585938 5.51757812 C-4.25585938 10.46757813 -4.25585938 15.41757813 -4.25585938 20.51757812 C12.90414063 20.51757812 30.06414063 20.51757812 47.74414062 20.51757812 C47.74414062 15.56757812 47.74414062 10.61757812 47.74414062 5.51757812 C45.31176067 4.30138815 43.75274279 4.39068908 41.03491211 4.38818359 C40.05727402 4.38503143 39.07963593 4.38187927 38.07237244 4.37863159 C36.4848391 4.38166794 36.4848391 4.38166794 34.86523438 4.38476562 C33.78282974 4.3838089 32.70042511 4.38285217 31.58522034 4.38186646 C29.29452456 4.38118515 27.00382685 4.38303601 24.71313477 4.38720703 C21.19282734 4.39256111 17.67264721 4.38725769 14.15234375 4.38085938 C11.93164034 4.38152006 9.71093701 4.38280103 7.49023438 4.38476562 C6.42985458 4.38274139 5.36947479 4.38071716 4.27696228 4.37863159 C2.81523338 4.38335983 2.81523338 4.38335983 1.32397461 4.38818359 C0.46174789 4.38897919 -0.40047882 4.38977478 -1.28883362 4.39059448 C-3.25877327 4.3004638 -3.25877327 4.3004638 -4.25585938 5.51757812 Z "
        fill="#B8B8B8"
        transform="translate(17.255859375,58.482421875)"
      />
      <path
        d="M0 0 C1.67542976 0.28604898 3.34385343 0.61781233 5 1 C4.67 2.65 4.34 4.3 4 6 C2.68 5.67 1.36 5.34 0 5 C-0.5625 3.0625 -0.5625 3.0625 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z "
        fill="#BABABA"
        transform="translate(48,30)"
      />
      <path
        d="M0 0 C1.67542976 0.28604898 3.34385343 0.61781233 5 1 C4.67 2.32 4.34 3.64 4 5 C2.68 5.33 1.36 5.66 0 6 C-0.38218767 4.34385343 -0.71395102 2.67542976 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z "
        fill="#BABABA"
        transform="translate(25,30)"
      />
    </svg>
  );
};

export const ControlsIcon = ({ style }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g stroke="#999999" strokeWidth="2" fill="none">
        <path d="M10 30 C 10 15, 25 10, 40 10 L 80 10 C 90 10, 90 20, 90 30 L 90 70 C 90 80, 80 90, 70 90 L 40 90 C 30 90, 20 80, 20 70 L 20 35 L 10 30 Z" />
        <text x="30" y="60" fontSize="20" stroke="#999999" fill="#999999">
          AI
        </text>
      </g>
      <g
        stroke="#999999"
        strokeWidth="2"
        fill="none"
        transform="translate(45, 45)"
      >
        <path d="M 30 0 L 45 15 L 45 40 C 45 60, 30 70, 15 70 C 0 70, -15 60, -15 40 L -15 15 L 0 0 Z" />
        <circle cx="0" cy="35" r="5" fill="#999999" stroke="none" />
        <circle cx="0" cy="35" r="10" />
        <path d="M -5 35 L 5 35 M 0 30 L 0 40 M -3 32 L 3 38 M -3 38 L 3 32" />
      </g>
    </svg>
  );
};

export const EnrollmentAIIcon = ({ style }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={style?.width || "116"}
    height={style?.height || "90"}
    viewBox="0 0 116 90"
    style={style}
  >
    <path
      d="M0 0 C38.28 0 76.56 0 116 0 C116 29.7 116 59.4 116 90 C77.72 90 39.44 90 0 90 C0 60.3 0 30.6 0 0 Z "
      fill="#FEFEFE"
      transform="translate(0,0)"
    />
    <path
      d="M0 0 C2.4375 1.8125 2.4375 1.8125 4 4 C4 5.32 4 6.64 4 8 C5.18078125 7.95359375 6.3615625 7.9071875 7.578125 7.859375 C9.13539134 7.82185051 10.69268508 7.78545107 12.25 7.75 C13.02730469 7.71648438 13.80460937 7.68296875 14.60546875 7.6484375 C18.26827909 7.58582536 20.37772735 7.6081987 23.53125 9.59375 C25.4924447 12.80677111 25.3994601 15.01349742 25.25 18.75 C25.21390625 19.92046875 25.1778125 21.0909375 25.140625 22.296875 C25.09421875 23.18890625 25.0478125 24.0809375 25 25 C25.78761719 25.14179687 26.57523437 25.28359375 27.38671875 25.4296875 C30 26 30 26 31.8125 27.125 C33.73573352 30.16168451 33.42275775 32.49715009 33 36 C31.25 38.9375 31.25 38.9375 29 41 C27.68 41 26.36 41 25 41 C25.0314209 41.92280762 25.0314209 41.92280762 25.06347656 42.86425781 C25.14677017 45.65933809 25.19870013 48.45415715 25.25 51.25 C25.28351563 52.21808594 25.31703125 53.18617187 25.3515625 54.18359375 C25.37089844 55.58544922 25.37089844 55.58544922 25.390625 57.015625 C25.4220459 58.30388184 25.4220459 58.30388184 25.45410156 59.61816406 C24.83544299 62.86312808 23.52676907 63.92053853 21 66 C18.60974121 66.50793457 18.60974121 66.50793457 15.92773438 66.51757812 C14.41596619 66.53649109 14.41596619 66.53649109 12.87365723 66.55578613 C11.25010315 66.54364075 11.25010315 66.54364075 9.59375 66.53125 C8.47689819 66.5350769 7.36004639 66.53890381 6.20935059 66.54284668 C3.84903054 66.54556756 1.48868043 66.5381942 -0.87158203 66.52148438 C-4.48668575 66.50007884 -8.09980193 66.52128178 -11.71484375 66.546875 C-14.00781689 66.54423176 -16.3007888 66.53910686 -18.59375 66.53125 C-19.67611938 66.53934692 -20.75848877 66.54744385 -21.87365723 66.55578613 C-22.88150269 66.54317749 -23.88934814 66.53056885 -24.92773438 66.51757812 C-25.81279663 66.51439575 -26.69785889 66.51121338 -27.60974121 66.50793457 C-30.77677488 65.83493385 -31.99130949 64.48423127 -34 62 C-34.45410156 59.61816406 -34.45410156 59.61816406 -34.390625 57.015625 C-34.37773438 56.08105469 -34.36484375 55.14648438 -34.3515625 54.18359375 C-34.31804688 53.21550781 -34.28453125 52.24742188 -34.25 51.25 C-34.23195313 50.26644531 -34.21390625 49.28289063 -34.1953125 48.26953125 C-34.14824126 45.84536217 -34.08250742 43.42317941 -34 41 C-35.17949219 40.81824219 -35.17949219 40.81824219 -36.3828125 40.6328125 C-39 40 -39 40 -40.875 37.875 C-42.3670761 34.06191664 -42.13941332 31.91673328 -41 28 C-38.5625 25.5625 -38.5625 25.5625 -36 24 C-35.34 24 -34.68 24 -34 24 C-34.04640625 23.18015625 -34.0928125 22.3603125 -34.140625 21.515625 C-34.17671875 20.43796875 -34.2128125 19.3603125 -34.25 18.25 C-34.29640625 17.18265625 -34.3428125 16.1153125 -34.390625 15.015625 C-34 12 -34 12 -32.53125 9.65625 C-28.86040423 7.25433857 -25.5545104 7.32852341 -21.25 7.25 C-20.45722656 7.22035156 -19.66445313 7.19070312 -18.84765625 7.16015625 C-16.89897906 7.08972213 -14.94948505 7.04256518 -13 7 C-12.70480469 6.21367187 -12.40960938 5.42734375 -12.10546875 4.6171875 C-9.5621428 -1.40411421 -5.99536196 -1.60590053 0 0 Z "
      fill="#FEFEFE"
      transform="translate(64,11)"
    />
    <path
      d="M0 0 C2.4375 1.8125 2.4375 1.8125 4 4 C4 5.32 4 6.64 4 8 C5.18078125 7.95359375 6.3615625 7.9071875 7.578125 7.859375 C9.13539134 7.82185051 10.69268508 7.78545107 12.25 7.75 C13.02730469 7.71648438 13.80460937 7.68296875 14.60546875 7.6484375 C18.26827909 7.58582536 20.37772735 7.6081987 23.53125 9.59375 C25.4924447 12.80677111 25.3994601 15.01349742 25.25 18.75 C25.21390625 19.92046875 25.1778125 21.0909375 25.140625 22.296875 C25.09421875 23.18890625 25.0478125 24.0809375 25 25 C25.78761719 25.14179687 26.57523437 25.28359375 27.38671875 25.4296875 C30 26 30 26 31.8125 27.125 C33.73573352 30.16168451 33.42275775 32.49715009 33 36 C31.25 38.9375 31.25 38.9375 29 41 C27.68 41 26.36 41 25 41 C25.0314209 41.92280762 25.0314209 41.92280762 25.06347656 42.86425781 C25.14677017 45.65933809 25.19870013 48.45415715 25.25 51.25 C25.28351563 52.21808594 25.31703125 53.18617187 25.3515625 54.18359375 C25.37089844 55.58544922 25.37089844 55.58544922 25.390625 57.015625 C25.4220459 58.30388184 25.4220459 58.30388184 25.45410156 59.61816406 C24.83544299 62.86312808 23.52676907 63.92053853 21 66 C18.60974121 66.50793457 18.60974121 66.50793457 15.92773438 66.51757812 C14.41596619 66.53649109 14.41596619 66.53649109 12.87365723 66.55578613 C11.25010315 66.54364075 11.25010315 66.54364075 9.59375 66.53125 C8.47689819 66.5350769 7.36004639 66.53890381 6.20935059 66.54284668 C3.84903054 66.54556756 1.48868043 66.5381942 -0.87158203 66.52148438 C-4.48668575 66.50007884 -8.09980193 66.52128178 -11.71484375 66.546875 C-14.00781689 66.54423176 -16.3007888 66.53910686 -18.59375 66.53125 C-19.67611938 66.53934692 -20.75848877 66.54744385 -21.87365723 66.55578613 C-22.88150269 66.54317749 -23.88934814 66.53056885 -24.92773438 66.51757812 C-25.81279663 66.51439575 -26.69785889 66.51121338 -27.60974121 66.50793457 C-30.77677488 65.83493385 -31.99130949 64.48423127 -34 62 C-34.45410156 59.61816406 -34.45410156 59.61816406 -34.390625 57.015625 C-34.37773438 56.08105469 -34.36484375 55.14648438 -34.3515625 54.18359375 C-34.31804688 53.21550781 -34.28453125 52.24742188 -34.25 51.25 C-34.23195313 50.26644531 -34.21390625 49.28289063 -34.1953125 48.26953125 C-34.14824126 45.84536217 -34.08250742 43.42317941 -34 41 C-35.17949219 40.81824219 -35.17949219 40.81824219 -36.3828125 40.6328125 C-39 40 -39 40 -40.875 37.875 C-42.3670761 34.06191664 -42.13941332 31.91673328 -41 28 C-38.5625 25.5625 -38.5625 25.5625 -36 24 C-35.34 24 -34.68 24 -34 24 C-34.04640625 23.18015625 -34.0928125 22.3603125 -34.140625 21.515625 C-34.17671875 20.43796875 -34.2128125 19.3603125 -34.25 18.25 C-34.29640625 17.18265625 -34.3428125 16.1153125 -34.390625 15.015625 C-34 12 -34 12 -32.53125 9.65625 C-28.86040423 7.25433857 -25.5545104 7.32852341 -21.25 7.25 C-20.45722656 7.22035156 -19.66445313 7.19070312 -18.84765625 7.16015625 C-16.89897906 7.08972213 -14.94948505 7.04256518 -13 7 C-12.70480469 6.21367187 -12.40960938 5.42734375 -12.10546875 4.6171875 C-9.5621428 -1.40411421 -5.99536196 -1.60590053 0 0 Z M-29 13 C-29.09319449 14.5348297 -29.117458 16.07392082 -29.11352539 17.61157227 C-29.11344986 18.59251358 -29.11337433 19.5734549 -29.11329651 20.5841217 C-29.10813522 21.6507756 -29.10297394 22.7174295 -29.09765625 23.81640625 C-29.0962413 24.9025975 -29.09482635 25.98878876 -29.09336853 27.1078949 C-29.08775048 30.59279075 -29.07519492 34.07762342 -29.0625 37.5625 C-29.05748733 39.91861887 -29.05292402 42.27473874 -29.04882812 44.63085938 C-29.03777519 50.42059464 -29.02101951 56.21029281 -29 62 C-22.03996553 62.02526838 -15.0799428 62.04283222 -8.11987305 62.05493164 C-5.75007688 62.05997341 -3.38028385 62.06680665 -1.01049805 62.07543945 C2.38754039 62.0875119 5.78553785 62.09322971 9.18359375 62.09765625 C10.25024765 62.10281754 11.31690155 62.10797882 12.4158783 62.11329651 C13.39681961 62.11337204 14.37776093 62.11344757 15.38842773 62.11352539 C16.25668686 62.115746 17.12494598 62.11796661 18.01951599 62.12025452 C20.00143681 62.21954667 20.00143681 62.21954667 21 61 C21.09831146 59.50129952 21.12798456 57.99801461 21.12939453 56.49609375 C21.13412277 55.05955444 21.13412277 55.05955444 21.13894653 53.59399414 C21.1369223 52.55235107 21.13489807 51.51070801 21.1328125 50.4375 C21.13376923 49.37587646 21.13472595 48.31425293 21.13571167 47.22045898 C21.13639364 44.97086528 21.13453819 42.72126963 21.13037109 40.47167969 C21.1250231 37.01492929 21.13031554 33.55830883 21.13671875 30.1015625 C21.13605797 27.92187471 21.13477682 25.742187 21.1328125 23.5625 C21.13483673 22.52085693 21.13686096 21.47921387 21.13894653 20.40600586 C21.13579437 19.44831299 21.13264221 18.49062012 21.12939453 17.50390625 C21.12859894 16.65642822 21.12780334 15.8089502 21.12698364 14.93579102 C21.21319708 12.9934287 21.21319708 12.9934287 20 12 C18.50129952 11.90168854 16.99801461 11.87201544 15.49609375 11.87060547 C14.53840088 11.86745331 13.58070801 11.86430115 12.59399414 11.86105347 C11.55235107 11.8630777 10.51070801 11.86510193 9.4375 11.8671875 C8.37587646 11.86623077 7.31425293 11.86527405 6.22045898 11.86428833 C3.97086528 11.86360636 1.72126963 11.86546181 -0.52832031 11.86962891 C-3.98507071 11.8749769 -7.44169117 11.86968446 -10.8984375 11.86328125 C-13.07812529 11.86394203 -15.257813 11.86522318 -17.4375 11.8671875 C-18.47914307 11.86516327 -19.52078613 11.86313904 -20.59399414 11.86105347 C-22.03053345 11.86578171 -22.03053345 11.86578171 -23.49609375 11.87060547 C-24.34357178 11.87140106 -25.1910498 11.87219666 -26.06420898 11.87301636 C-28.0065713 11.78680292 -28.0065713 11.78680292 -29 13 Z "
      fill="#B8B8B8"
      transform="translate(64,11)"
    />
    <path
      d="M0 0 C9.57 0 19.14 0 29 0 C29 1.32 29 2.64 29 4 C19.43 4 9.86 4 0 4 C0 2.68 0 1.36 0 0 Z "
      fill="#B8B8B8"
      transform="translate(45,59)"
    />
    <path
      d="M0 0 C2.4375 0.1875 2.4375 0.1875 3.4375 1.1875 C3.625 3.625 3.625 3.625 3.4375 6.1875 C2.7775 6.8475 2.1175 7.5075 1.4375 8.1875 C-1.1875 7.8125 -1.1875 7.8125 -3.5625 7.1875 C-4.1875 4.8125 -4.1875 4.8125 -4.5625 2.1875 C-2.5625 0.1875 -2.5625 0.1875 0 0 Z "
      fill="#B9B9B9"
      transform="translate(72.5625,37.8125)"
    />
    <path
      d="M0 0 C2.4375 0.1875 2.4375 0.1875 3.4375 1.1875 C3.625 3.625 3.625 3.625 3.4375 6.1875 C2.7775 6.8475 2.1175 7.5075 1.4375 8.1875 C-1.1875 7.8125 -1.1875 7.8125 -3.5625 7.1875 C-4.1875 4.8125 -4.1875 4.8125 -4.5625 2.1875 C-2.5625 0.1875 -2.5625 0.1875 0 0 Z "
      fill="#B8B8B8"
      transform="translate(47.5625,37.8125)"
    />
  </svg>
);

export const BotIcon = (props) => (
  <svg
    width="34"
    height="35"
    viewBox="0 0 34 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.46875"
      y="0.976562"
      width="33.4021"
      height="33.4021"
      rx="16.7011"
      fill="#E6EAF1"
    />
    <path
      d="M22.3094 14.0823H17.6817V11.8679C17.8361 11.7805 17.9649 11.654 18.0551 11.5012C18.1454 11.3484 18.1939 11.1746 18.1959 10.9971C18.1959 10.7244 18.0875 10.4628 17.8947 10.27C17.7018 10.0771 17.4402 9.96875 17.1675 9.96875C16.8947 9.96875 16.6332 10.0771 16.4403 10.27C16.2474 10.4628 16.1391 10.7244 16.1391 10.9971C16.1411 11.1746 16.1896 11.3484 16.2798 11.5012C16.3701 11.654 16.4989 11.7805 16.6533 11.8679V14.0823H12.0255C11.4802 14.0829 10.9574 14.2998 10.5719 14.6854C10.1863 15.071 9.96937 15.5938 9.96875 16.1391V23.3378C9.96937 23.8831 10.1863 24.4059 10.5719 24.7915C10.9574 25.1771 11.4802 25.394 12.0255 25.3946H22.3094C22.8547 25.394 23.3775 25.1771 23.7631 24.7915C24.1487 24.4059 24.3656 23.8831 24.3662 23.3378V16.1391C24.3656 15.5938 24.1487 15.071 23.7631 14.6854C23.3775 14.2998 22.8547 14.0829 22.3094 14.0823ZM23.3378 23.3378C23.3376 23.6105 23.2291 23.8719 23.0363 24.0647C22.8435 24.2575 22.5821 24.366 22.3094 24.3662H12.0255C11.7529 24.366 11.4915 24.2575 11.2987 24.0647C11.1058 23.8719 10.9974 23.6105 10.9971 23.3378V16.1391C10.9974 15.8664 11.1058 15.605 11.2987 15.4122C11.4915 15.2194 11.7529 15.111 12.0255 15.1107H22.3094C22.5821 15.111 22.8435 15.2194 23.0363 15.4122C23.2291 15.605 23.3376 15.8664 23.3378 16.1391V23.3378ZM14.0823 20.2527C13.8789 20.2527 13.6801 20.1923 13.511 20.0793C13.3419 19.9663 13.21 19.8057 13.1322 19.6178C13.0544 19.4299 13.034 19.2231 13.0737 19.0236C13.1134 18.8242 13.2113 18.6409 13.3551 18.4971C13.499 18.3533 13.6822 18.2553 13.8817 18.2156C14.0812 18.176 14.2879 18.1963 14.4759 18.2742C14.6638 18.352 14.8244 18.4838 14.9374 18.6529C15.0504 18.822 15.1107 19.0209 15.1107 19.2243C15.1107 19.497 15.0024 19.7586 14.8095 19.9515C14.6166 20.1443 14.3551 20.2527 14.0823 20.2527ZM21.2811 19.2243C21.2811 19.4277 21.2207 19.6265 21.1077 19.7956C20.9947 19.9647 20.8341 20.0965 20.6462 20.1744C20.4583 20.2522 20.2515 20.2726 20.052 20.2329C19.8525 20.1932 19.6693 20.0953 19.5255 19.9515C19.3817 19.8076 19.2837 19.6244 19.244 19.4249C19.2043 19.2254 19.2247 19.0186 19.3026 18.8307C19.3804 18.6428 19.5122 18.4822 19.6813 18.3692C19.8504 18.2562 20.0493 18.1959 20.2527 18.1959C20.5254 18.1959 20.787 18.3042 20.9798 18.4971C21.1727 18.6899 21.2811 18.9515 21.2811 19.2243Z"
      fill="black"
    />
  </svg>
);

export const UserIcon = (props) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.109375"
      y="0.179688"
      width="33.4021"
      height="33.4021"
      rx="16.7011"
      fill="#9DA6B6"
    />
    <path
      d="M21.8565 22.921L21.8568 22.9199C22.0194 22.3796 22.1022 21.8165 22.1022 21.2452C22.1022 19.1419 20.9698 17.2603 19.2215 16.3221C19.8831 15.6562 20.2953 14.7221 20.2953 13.6886C20.2953 11.6799 18.7373 10.0332 16.806 10.0332C14.8747 10.0332 13.3168 11.6805 13.3168 13.6892C13.3168 14.7221 13.7289 15.6567 14.3905 16.3227C12.6422 17.2603 11.5098 19.142 11.5098 21.2459C11.5098 21.8171 11.592 22.3802 11.7559 22.9226L11.7559 22.9226L11.7562 22.9236C11.9 23.3887 12.3081 23.7102 12.7798 23.7102H20.8323C21.305 23.7102 21.7122 23.3877 21.8565 22.921ZM14.2316 13.6892C14.2316 12.188 15.3938 10.979 16.806 10.979C18.2182 10.979 19.3804 12.188 19.3804 13.6892C19.3804 15.1905 18.2182 16.3995 16.806 16.3995C15.3938 16.3995 14.2316 15.1905 14.2316 13.6892ZM12.4247 21.2452C12.4247 19.325 13.5539 17.6311 15.2408 16.954C15.7114 17.2029 16.2429 17.3446 16.806 17.3446C17.3691 17.3446 17.9006 17.2029 18.3712 16.954C20.0581 17.6311 21.1874 19.325 21.1874 21.2452C21.1874 21.721 21.1186 22.1895 20.9843 22.6356C20.9564 22.7251 20.8923 22.7651 20.8323 22.7651H12.7798C12.7191 22.7651 12.6553 22.7244 12.6283 22.638C12.4934 22.1894 12.4247 21.7209 12.4247 21.2452Z"
      fill="#E6EAF1"
      stroke="#E6EAF1"
      strokeWidth="0.308517"
    />
  </svg>
);

export const DefaultChatIcon = (props) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer square */}
    <rect width="60" height="60" fill="#007bff" />

    {/* Chat bubble inside the square */}
    <path d="M15 20 H45 V35 H30 L23 40 V35 H15 Z" fill="#ffffff" />
  </svg>
);

export const SearchIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1518_20058)">
      <path
        d="M8.16667 14.5599C11.8486 14.5599 14.8333 11.5751 14.8333 7.89323C14.8333 4.21133 11.8486 1.22656 8.16667 1.22656C4.48477 1.22656 1.5 4.21133 1.5 7.89323C1.5 11.5751 4.48477 14.5599 8.16667 14.5599Z"
        stroke="#9DA6B6"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16.2266L12.875 12.6016"
        stroke="#9DA6B6"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1518_20058">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AttachmentIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4192 18.3726L11.4193 18.3724L15.586 11.1555C15.9937 10.4495 16.0922 9.60498 15.862 8.80854C15.6318 8.01237 15.0921 7.32924 14.3625 6.90803C13.6329 6.48682 12.7714 6.36092 11.9669 6.55969C11.162 6.75852 10.48 7.26613 10.0723 7.97217L5.90565 15.1891C5.82954 15.3209 5.81168 15.4777 5.85406 15.6243C5.89636 15.7707 5.99513 15.895 6.1275 15.9715C6.25988 16.0479 6.41697 16.0712 6.56486 16.0347C6.71302 15.9981 6.8399 15.9042 6.91602 15.7724L11.0827 8.55551C11.3381 8.11313 11.7664 7.79328 12.2749 7.66765C12.7837 7.54196 13.331 7.62117 13.7958 7.88952C14.2606 8.15788 14.6029 8.59227 14.7484 9.09575C14.8939 9.59897 14.8311 10.1298 14.5757 10.5722L10.409 17.7891C9.93257 18.6142 9.13417 19.2099 8.18784 19.4437C7.24125 19.6775 6.22431 19.53 5.36139 19.0317C4.49847 18.5335 3.86219 17.7266 3.59141 16.7899C3.32071 15.8535 3.43738 14.8642 3.9138 14.0391L8.49713 6.10048C9.19456 4.8925 10.3631 4.02101 11.7472 3.67907C13.1316 3.33707 14.6181 3.55302 15.8792 4.28108C17.1402 5.00915 18.0705 6.18856 18.4665 7.55848C18.8624 8.92812 18.692 10.3758 17.9945 11.5838L13.4112 19.5224C13.3351 19.6542 13.3172 19.811 13.3596 19.9577L13.5037 19.916L13.3596 19.9577C13.4019 20.104 13.5007 20.2284 13.6331 20.3048C13.7654 20.3812 13.9225 20.4046 14.0704 20.368L14.0344 20.2224L14.0704 20.368C14.2186 20.3314 14.3455 20.2376 14.4216 20.1057L19.0049 12.1672C19.8546 10.6955 20.0608 8.93413 19.5801 7.27126C19.0994 5.60866 17.9716 4.18051 16.4458 3.29959C14.92 2.41867 13.1193 2.15603 11.4391 2.5711C9.75871 2.98625 8.33643 4.04549 7.48677 5.51715L2.90343 13.4557L2.90329 13.456C2.27708 14.5453 2.12603 15.8474 2.48127 17.0763C2.83644 18.3049 3.66865 19.3605 4.7945 20.0131L4.79495 20.0134L4.9245 20.0885L4.92585 20.0861C6.02515 20.6762 7.301 20.8432 8.49491 20.5483C9.73679 20.2415 10.7889 19.4596 11.4192 18.3726Z"
      fill="#7B7B7B"
      stroke="#7B7B7B"
      strokeWidth="0.3"
    />
  </svg>
);

export const OptionsMenuIcon = (props) => (
  <svg
    width="6"
    height="25"
    viewBox="0 0 6 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="2.76923"
      cy="3.26923"
      r="2.26923"
      fill="#4C5A71"
      stroke="white"
    />
    <circle
      cx="2.76923"
      cy="12.5036"
      r="2.26923"
      fill="#4C5A71"
      stroke="white"
    />
    <circle
      cx="2.76923"
      cy="21.7302"
      r="2.26923"
      fill="#4C5A71"
      stroke="white"
    />
  </svg>
);

export const CloseIcon = (props) => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1406 3L3.00561 21"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.00561 3L20.1406 21"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActiveIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill="#05C168" />
  </svg>
);

export const NavigationIcons = (props) => {
  switch (props.icon) {
    case "delete":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z" />
        </svg>
      );
    case "home":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.6623 9.28792L12.0031 2L2.33507 9.28792C2.1352 9.47236 2.01502 9.72738 2 9.99893V21.1281C2.0007 21.3584 2.09251 21.5791 2.25536 21.742C2.41822 21.9048 2.6389 21.9966 2.86922 21.9973H8.66578V17.334C8.66578 16.45 9.01692 15.6023 9.64196 14.9772C10.267 14.3522 11.1147 14.0011 11.9987 14.0011C12.8826 14.0011 13.7303 14.3522 14.3554 14.9772C14.9804 15.6023 15.3316 16.45 15.3316 17.334V22H21.1272C21.3576 21.9993 21.5784 21.9075 21.7414 21.7447C21.9044 21.5819 21.9964 21.3612 21.9973 21.1308V9.99893C21.9819 9.72748 21.8618 9.47258 21.6623 9.28792Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "knowledge":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0016 21.6406C13.9792 21.6403 15.9124 21.0536 17.5567 19.9547C19.2009 18.8557 20.4824 17.2939 21.2391 15.4667C21.9958 13.6395 22.1937 11.629 21.8078 9.68934C21.4219 7.74968 20.4695 5.96799 19.0711 4.56956C17.6726 3.17113 15.8909 2.21876 13.9513 1.83285C12.0116 1.44695 10.0011 1.64485 8.17389 2.40153C6.34669 3.15822 4.78489 4.4397 3.68596 6.08395C2.58702 7.7282 2.00031 9.66138 2 11.6391C1.99979 12.9525 2.25835 14.2532 2.7609 15.4667C3.26346 16.6803 4.00016 17.7829 4.92893 18.7117C5.8577 19.6405 6.96035 20.3772 8.17389 20.8797C9.38743 21.3823 10.6881 21.6408 12.0016 21.6406V21.6406Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.5 14.7734H21.2137"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.5 8.5H21.2137"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.8405 1.875C8.04566 8.35098 8.30989 15.2249 10.5966 21.544"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.1576 1.875C14.9416 4.69329 15.3374 7.60538 15.3341 10.5307C15.342 14.2857 14.6922 18.0132 13.4141 21.544"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "controls":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.38201 21.4088C5.00533 21.7855 4.49443 21.9971 3.96172 21.9971C3.42901 21.9971 2.91811 21.7855 2.54143 21.4088C2.16474 21.0321 1.95312 20.5212 1.95312 19.9885C1.95312 19.4558 2.16474 18.9449 2.54143 18.5682L8.22259 12.8906L11.0632 15.7312L5.38201 21.4088Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6883 6.25781L9.64062 14.3055"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5828 6.25998C19.3316 6.51106 18.9909 6.65208 18.6357 6.65199C18.2806 6.65191 17.94 6.51074 17.6889 6.25953C17.4378 6.00833 17.2968 5.66768 17.2969 5.31251C17.297 4.95734 17.4381 4.61675 17.6893 4.36566L20.0568 2L21.9502 3.89253L19.5828 6.25998Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.6514 8.71382L8.60715 6.66507C8.84511 6.05919 8.90116 5.39705 8.76845 4.75978C8.63573 4.12252 8.32001 3.53781 7.85996 3.07729C7.3214 2.54253 6.61542 2.20909 5.8603 2.13281C6.18083 2.64506 6.31826 3.25083 6.25015 3.85125C6.18204 4.45166 5.91242 5.01126 5.48529 5.43869C5.05817 5.86613 4.49877 6.13616 3.8984 6.2047C3.29804 6.27325 2.69217 6.13626 2.17969 5.81611C2.23299 6.32614 2.40365 6.81691 2.67831 7.24996C2.95297 7.68302 3.32417 8.0466 3.76282 8.31223C4.20147 8.57786 4.69567 8.73832 5.20669 8.78105C5.71772 8.82377 6.2317 8.7476 6.70837 8.55849L8.11527 9.96539"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9922 15.8482L15.5767 17.4319C15.2958 18.1478 15.2699 18.9387 15.5035 19.6715C15.7371 20.4042 16.2159 21.0342 16.8594 21.4555C17.5028 21.8768 18.2717 22.0637 19.0368 21.9847C19.8018 21.9057 20.5163 21.5657 21.0602 21.0219C21.604 20.478 21.944 19.7635 22.023 18.9985C22.1019 18.2334 21.9151 17.4645 21.4938 16.8211C21.0725 16.1776 20.4425 15.6988 19.7098 15.4652C18.977 15.2317 18.1861 15.2575 17.4702 15.5385L15.2286 13.2969"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.4573 18.4107C18.5041 18.3638 18.5637 18.3319 18.6287 18.319C18.6936 18.306 18.761 18.3126 18.8222 18.3379C18.8833 18.3633 18.9357 18.4062 18.9725 18.4612C19.0093 18.5163 19.0289 18.581 19.0289 18.6473C19.0289 18.7135 19.0093 18.7782 18.9725 18.8333C18.9357 18.8884 18.8833 18.9313 18.8222 18.9566C18.761 18.9819 18.6936 18.9885 18.6287 18.9756C18.5637 18.9626 18.5041 18.9307 18.4573 18.8838C18.3946 18.8211 18.3594 18.736 18.3594 18.6473C18.3594 18.5586 18.3946 18.4735 18.4573 18.4107"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "integrations":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2743_6459)">
            <path
              d="M23.0002 1H1C1 1 1.0002 1.65665 1.0002 2.46667V21.5333C1.0002 22.3434 1.00042 23 1.00042 23H23.0002V21.5333V2.46667V1Z"
              stroke="#4C5A71"
              strokeWidth="1.5"
              strokeLinecap="square"
            />
            <path
              d="M12.9766 15.6641H18.5988"
              stroke="#4C5A71"
              strokeWidth="1.5"
              strokeLinecap="square"
            />
            <path
              d="M5.39844 15.6641H8.08733"
              stroke="#4C5A71"
              strokeWidth="1.5"
              strokeLinecap="square"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.9748 15.6632C12.9748 16.1467 12.8315 16.6193 12.5629 17.0213C12.2943 17.4232 11.9125 17.7366 11.4658 17.9216C11.0192 18.1066 10.5277 18.155 10.0535 18.0607C9.57932 17.9664 9.14376 17.7335 8.8019 17.3917C8.46004 17.0498 8.22723 16.6143 8.13291 16.1401C8.03859 15.6659 8.087 15.1744 8.27201 14.7277C8.45703 14.2811 8.77034 13.8993 9.17232 13.6307C9.57431 13.3621 10.0469 13.2188 10.5304 13.2188C11.1787 13.2188 11.8004 13.4763 12.2589 13.9347C12.7173 14.3931 12.9748 15.0149 12.9748 15.6632V15.6632Z"
              stroke="#4C5A71"
              strokeWidth="1.5"
              strokeLinecap="square"
            />
            <path
              d="M13.954 8.33594H5.39844"
              stroke="#4C5A71"
              strokeWidth="1.5"
              strokeLinecap="square"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.842 8.33507C18.842 7.85161 18.6987 7.379 18.4301 6.97701C18.1615 6.57502 17.7797 6.26171 17.333 6.0767C16.8864 5.89168 16.3949 5.84328 15.9207 5.9376C15.4465 6.03191 15.0109 6.26473 14.6691 6.60659C14.3272 6.94845 14.0944 7.38401 14.0001 7.85818C13.9058 8.33236 13.9542 8.82386 14.1392 9.27052C14.3242 9.71718 14.6375 10.099 15.0395 10.3676C15.4415 10.6362 15.9141 10.7795 16.3976 10.7795C17.0459 10.7795 17.6676 10.522 18.1261 10.0636C18.5845 9.60513 18.842 8.98338 18.842 8.33507Z"
              stroke="#4C5A71"
              strokeWidth="1.5"
              strokeLinecap="square"
            />
          </g>
          <defs>
            <clipPath id="clip0_2743_6459">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "appearance":
      return (
        <svg
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.0026 20.9994C3.29536 20.9994 2.61708 20.7184 2.11699 20.2183C1.61689 19.7183 1.33594 19.04 1.33594 18.3327V6.13718C1.33707 5.72345 1.43445 5.31566 1.62038 4.94606L3.39816 1.39051C3.45367 1.28015 3.53876 1.18739 3.64392 1.12258C3.74908 1.05776 3.87018 1.02344 3.99372 1.02344C4.11725 1.02344 4.23835 1.05776 4.34351 1.12258C4.44867 1.18739 4.53376 1.28015 4.58927 1.39051L6.36705 4.94606C6.55298 5.31566 6.65036 5.72345 6.65149 6.13718V18.3327C6.65151 19.0369 6.373 19.7125 5.87674 20.2121C5.38048 20.7117 4.70676 20.9947 4.0026 20.9994V20.9994Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M1.33594 6.10938H6.66927"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M1.33594 16.7812H6.66927"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M17.3385 1H12.0052C11.2688 1 10.6719 1.59695 10.6719 2.33333V19.6667C10.6719 20.403 11.2688 21 12.0052 21H17.3385C18.0749 21 18.6719 20.403 18.6719 19.6667V2.33333C18.6719 1.59695 18.0749 1 17.3385 1Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M10.6719 5H13.783"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M10.6719 9H13.783"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M10.6719 13H13.783"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M10.6719 17H13.783"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </svg>
      );

    case "ai-personality":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7487 5.14125C11.0744 5.13278 10.4019 5.21347 9.74876 5.38124C6.83601 6.11098 4.02637 8.38732 2.13046 10.7054C1.88399 11.0188 1.75 11.4058 1.75 11.8045C1.75 12.2031 1.88399 12.5902 2.13046 12.9035C3.99704 15.1825 6.79957 17.4989 9.75232 18.2366C10.4045 18.4027 11.0757 18.4825 11.7487 18.4739C12.4228 18.4828 13.0952 18.403 13.7486 18.2366C16.7013 17.5016 19.5065 15.1843 21.3695 12.9035C21.616 12.5902 21.75 12.2031 21.75 11.8045C21.75 11.4058 21.616 11.0188 21.3695 10.7054C19.4727 8.38643 16.6587 6.11009 13.7486 5.38035C13.0954 5.21302 12.4229 5.13263 11.7487 5.14125V5.14125Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="11.7553"
            cy="11.56"
            r="1.9428"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "smart-probe":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7487 5.14125C11.0744 5.13278 10.4019 5.21347 9.74876 5.38124C6.83601 6.11098 4.02637 8.38732 2.13046 10.7054C1.88399 11.0188 1.75 11.4058 1.75 11.8045C1.75 12.2031 1.88399 12.5902 2.13046 12.9035C3.99704 15.1825 6.79957 17.4989 9.75232 18.2366C10.4045 18.4027 11.0757 18.4825 11.7487 18.4739C12.4228 18.4828 13.0952 18.403 13.7486 18.2366C16.7013 17.5016 19.5065 15.1843 21.3695 12.9035C21.616 12.5902 21.75 12.2031 21.75 11.8045C21.75 11.4058 21.616 11.0188 21.3695 10.7054C19.4727 8.38643 16.6587 6.11009 13.7486 5.38035C13.0954 5.21302 12.4229 5.13263 11.7487 5.14125V5.14125Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="11.7553"
            cy="11.56"
            r="1.9428"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "bot-testing":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.34563 7.99219L2 12.0021L7.34563 16.0121"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M16.6562 7.99219L22.0033 12.0021L16.6562 16.0121"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M13.3369 5.32031L10.6641 18.6873"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </svg>
      );

    case "clients":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.3333 20.3073C20.3333 20.6609 20.1929 21.0001 19.9428 21.2501C19.6928 21.5002 19.3536 21.6406 19 21.6406H4.33333C3.97971 21.6406 3.64057 21.5002 3.39052 21.2501C3.14048 21.0001 3 20.6609 3 20.3073V2.97396C3 2.62034 3.14048 2.2812 3.39052 2.03115C3.64057 1.7811 3.97971 1.64063 4.33333 1.64062H13.7813C14.1347 1.6407 14.4736 1.78105 14.7236 2.03085L19.9431 7.2504C20.1929 7.50036 20.3333 7.83925 20.3333 8.19262V20.3073Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.2639 7.89062L8.36883 10.4168C8.31149 10.4932 8.23843 10.5563 8.15458 10.602C8.07074 10.6477 7.97806 10.6748 7.88282 10.6815C7.78759 10.6883 7.69202 10.6745 7.60257 10.6411C7.51313 10.6077 7.4319 10.5555 7.36438 10.488L6.33594 9.4604"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.2639 13.8906L8.36883 16.4168C8.31149 16.4932 8.23843 16.5563 8.15458 16.602C8.07074 16.6477 7.97806 16.6748 7.88282 16.6815C7.78759 16.6883 7.69202 16.6745 7.60257 16.6411C7.51313 16.6077 7.4319 16.5555 7.36438 16.488L6.33594 15.4595"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 10.6797H17"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 16.0156H17"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "users":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.25 22V20.75C3.25 19.6009 3.47633 18.4631 3.91605 17.4015C4.35578 16.3399 5.0003 15.3753 5.81282 14.5628C6.62533 13.7503 7.58992 13.1058 8.65152 12.6661C9.71312 12.2263 10.8509 12 12 12C13.1491 12 14.2869 12.2263 15.3485 12.6661C16.4101 13.1058 17.3747 13.7503 18.1872 14.5628C18.9997 15.3753 19.6442 16.3399 20.0839 17.4015C20.5237 18.4631 20.75 19.6009 20.75 20.75V22"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 12C13.3261 12 14.5979 11.4732 15.5355 10.5355C16.4732 9.59785 17 8.32608 17 7C17 5.67392 16.4732 4.40215 15.5355 3.46447C14.5979 2.52678 13.3261 2 12 2C10.6739 2 9.40215 2.52678 8.46447 3.46447C7.52678 4.40215 7 5.67392 7 7C7 8.32608 7.52678 9.59785 8.46447 10.5355C9.40215 11.4732 10.6739 12 12 12V12Z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    // TODO: Update these icons once we have it
    case "personalization":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14l-3-3 1.41-1.41L11 13.17l4.59-4.59L17 10l-6 6z"
            fill="#4C5A71"
          />
        </svg>
      );
    case "access-control":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 17c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm-9 3h18v-2c0-2.67-5.33-4-8-4s-8 1.33-8 4v2zm3-.89c.16-.81 2.91-1.61 5-1.61 2.09 0 4.84.8 5 1.61H6zm11-11.44V10H7V9.67C7.4 7.92 9.14 6 11 6c1.86 0 3.6 1.84 4 3.67z"
            fill="#4C5A71"
            stroke="#4C5A71"
            strokeWidth="1.5"
          />
        </svg>
      );
    case "dynamic-user-profiles":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
            fill="#4C5A71"
          />
        </svg>
      );
    case "insights-analytics":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 17h18v2H3v-2zm2-5l2.5 3.5L9.5 13l2 2.5L17 8l4 5v2H3v-2h2zm10.5-5c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
            fill="#4C5A71"
          />
        </svg>
      );
    case "admin":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 2.18l7 3.12v4.7c0 4.52-3.05 8.8-7 9.88-3.95-1.08-7-5.36-7-9.88V6.3l7-3.12z"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12l2 2 4-4"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "user-profiling":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="7"
            r="4"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "debug":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="10"
            cy="10"
            r="6"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5 14.5L20 20"
            stroke="#4C5A71"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="10"
            cy="8"
            r="1"
            fill="#4C5A71"
          />
          <ellipse
            cx="8"
            cy="11"
            rx="1"
            ry="1.5"
            fill="#4C5A71"
          />
          <ellipse
            cx="12"
            cy="11"
            rx="1"
            ry="1.5"
            fill="#4C5A71"
          />
          <path
            d="M10 8V10"
            stroke="#4C5A71"
            strokeWidth="1"
            strokeLinecap="round"
          />
          <path
            d="M7 9L8 10.5"
            stroke="#4C5A71"
            strokeWidth="1"
            strokeLinecap="round"
          />
          <path
            d="M13 9L12 10.5"
            stroke="#4C5A71"
            strokeWidth="1"
            strokeLinecap="round"
          />
          <path
            d="M6.5 12L8 12.5"
            stroke="#4C5A71"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
          <path
            d="M13.5 12L12 12.5"
            stroke="#4C5A71"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
        </svg>
      );
  }
};

export const InsyncIcon = (props) => {
  return (
    <svg
      width="102"
      height="24"
      viewBox="0 0 102 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="101.455" height="24" fill="url(#pattern0_1518_36152)" />
      <defs>
        <pattern
          id="pattern0_1518_36152"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1518_36152"
            transform="matrix(0.00505051 0 0 0.0213499 0 -0.0123967)"
          />
        </pattern>
        <image
          id="image0_1518_36152"
          width="198"
          height="48"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMYAAAAwCAMAAAB9jvVrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAHdUExURf////9fAP////////5fAP////3///9cAP///////////wC9//9dAP///wC////////+/wC3/////////wCYuQCatwC/+wC6/////////////xeMpQCXtgC+//5gAPthAP////9aAv////1eAP///wDB+////wCUvQC/9wC8/wCWuADC/wCVuf1gAP///wC+/QC6/eJnGwKQuwG++fViAAC97gCXxwC79fFmBf9XAACav/hiAgC8/P/+//+NBwCWtACVwwW28vteAwK0/f+AAf+SBDejyvleCv1dABat6Ayl25iIXQC7+xiv3hC27QC+85GKZvdgDBuMqwCZtPlpAPdlCQaRwhmItQCTzAC16uRnHQGUtbt6PQuv8gCk1ftlAACbvlKeotNwIjCq0WOXmrp3R+dkHQC0/Ll3TyGHpv9dABO04+hzIwCz6P9aB/VhC/9dAu5jDwm49RqIq/hgAfCZABDD+X6QfPWVAP9wANRxEgC78gCfxd9sJhav2d1zCc54G/GJFQ6LtACe2Ru02+OCIgCSwv9eADaixfmEAAGOzgG3///+/wGUtP3///3///3////+/yKsy/lYAP////GOJOhmEHuMgkGgs8F1PhVpAFEA/wD/AEdwTEdwTJOpUm4AAACfdFJOU///QMD/gP//v/AQ//8w/+D//9Bg/////6B/IED/////UP+w/5D/cP////////+f/z+A/////7////+///BA/////////v//uuAfEP///2Ds/BC///9goL//4TD/////////////gP+l84CQqD7/IKCAUIAw8P//////gMD//z3//3Bw68Cv6/CA///A0OugMECw/zBP5vA/PxD///AAAOwTCYQAAAaCSURBVGje1Zn3d9pIEMdlCQ4khLFB1ANEM6aTUA58dhyDux23c7rT26X3Xi653nv/RX/r7UqriuwIOe8M37wXNlkxu5+d2Z3RgnGSNq4vWDoUZR/O/8516MDQ0NAPMa5nhEmt2zoQFkuSZc8+O6KLMTR0oAcx5vUoLO324WczMzf1MX7tPYwjuhRFtnZ4ZnLyT30MoucwNh7qU4wDitnZyU/7BOM6vY0zIMXs5Ex/YJy0WfSDanxy9umjR0+//bLzq7i15zDmtRg0TVuS4KC6t9OXnT2Gca+d1GDYxsbodjI6/25GwUP/B8bGgk2LQQOMpGX85HZ+sAP9Alsp2LIDv8RKsBHUeggvuTEo0p6WWazBYJpSPhUKQuFKezjfSuGdg3tKLmjRXcLVGHfjIKai0WhHXN3Zdnmx94B+Bi0CfGIYMEhgglzKgXEXplBJnDrPFVLZg7JyohmlPU2xkCZlg1IfxLg9Fgc7QY1RZFm6/de/O2P8pIcBZiuvOqYW6ZQxsIAxDAxLKBwXcqst2ikJYz5us9EDGm8ULfErl7mdMQh9DMxN6VNIHHybMIoh2QPBTGotup0I42YcYmiDKlm7cvXvfz7ZJ2nROAbyhxPrlN0MBvqWHgViBBgLScCRLBZVGMn2lVNP5k5PDw/7/Vkg/6HWjbdgkAQh7QQ+ZgNCO8Wvl8el6DGEobSX5p+i5J3mdqkYMe4uy9ritvb4OMuCXW1h2SLc3MnahfXzK9MAQsAAHNXVHTH4yeIodF3SZDEP+grllneEEQz+pMCRT0g+rFJo4gTfFxP9BUbANr4eoGkbzTabzRptsyVrNXYAfLabpy6ttBr1ejUbgXL4/Zkv1MMiDHFYpIC06JQMpJgqYRRDbQ8uRgghSZ1pac2wOzZellqzxgoYUfARb15Ynms1AIZvkFckmy3fMIKBHJ8Sp0bKx4wpDE5wYkJ2hiIzeURGLC5ggPwXH4uDnV6MAu/Q9Kvl8yu+csSRjQwiRSYWjWAg04QUVC4P1Zl0u8CICXsBtKQFkkUgRmwhzstGg/LDRsPgGj97uPnq6qXf6r78oBLjPmcIIyTNUTpr3KU0TpnFEGITEw2TKkM4AQUwjiBv8Jt7gG5eePP69ZtTy5cuthoAo1wtA/FBtbbUMawuhjxHXHUwuhJyNdINBidi4FJ06dVUJ/cjPX++f//ly+vry8vrT87PnR72V/P5aqMqYDj8q1y3GGLoykqEdoHhkZ7Z6V1c0Ddzc3MXL66stOBBm89nMplqtVqODGa/57rH0JRUMCRi5jGsxjGWJqb5jMenC0d+ZCQD5SuX/YtmMMAGDbh1qpFdBFXACMaNxjCSPxvJ5/M+4AsIMnKfM4fBP5xOEeq6whSGU5OH+P3PF/hBDca+eibr9yOOwXx+xFeGINXqxNIuMJBbEEdIMbOuMDhSVRUoik+3BuOFD+xlPwLxO3y+EfAHVCKOVa57DA//AiSPiuo6XJpQrEsMYSFcihMXmUyrMVbrjx9XG0Ct1vT09KFDmQbY4Q5QTr3gTGBYtdkqIK1mQjshQxj4dmV7SMC4duzYsY+APoT6AAk2T6ytTQCtfWIGo6MYcUuPerQTMoQh5lM36vUgigDa4g++O358qrK1xXi9XoYZhSqENze9U2du1cGJ1TjBmcGgSNVLLVUSBuWnjibgCoa40B8xoxhSPnWn0sGSeJjDhRKC6ujxqdFKpcJ4mRzDMLlcOJzbyh1kpqbO1MtZ//CiKQyprnYlwGFiFzOgolBCshrF6Myn4hYTupe+mhodhRi5nNe7ubkJMAqFXGG08rJedQx/zJnDoFydY4oXCQFTGKqvYYr3GdT92SiYdY7xhsNeXjC0GKZw7tzLW6dPcCYxdN45SafmPcIABqk8ndNagx5V+ju6FUYCEGEvU4AYYcZ77szni11iJOS8EUqoByWcnM6tyVswAqoko65vRINS97Uft7YOAkES8HehUoGtTeboEtclBn8HI6Y/PCB7JKC+OguJXW/BoAh1rvRIJUEC1ylGHryvo20ueCgcCi6Fk2+p34ycQpf4L48VKI3rrQbswVUHrp69EPgf9ehag1hvXCXvVIR396PZnsraEUr9gBHQvzeg+gzDqboLFLNhguu3oHKr7qwVtW9/YaDqyI7zv21gu3XGnm3xVMdlLEn1IUZHdUTu6ofEvTtwrTo/U/Rj3lBUR6R1l7b2NP3h/O0PmfBQXD9jvDv9BzjxJwYjIB0kAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};

export const MenuExpand = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 11.625L9 6.375L3.75 11.625"
      stroke="#4C5A71"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuShrink = (props) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 1.375L6 6.625L11.25 1.375"
      stroke="#4C5A71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.64062V20.6406"
      stroke="#327DF6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 11.6406H21"
      stroke="#327DF6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterButton = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.4986 3.07203C22.5045 2.9808 22.4917 2.88931 22.461 2.80322C22.4302 2.71712 22.3821 2.63825 22.3197 2.57147C22.2572 2.50469 22.1818 2.45141 22.0979 2.41493C22.0141 2.37845 21.9237 2.35955 21.8322 2.35938H3.16782C3.07635 2.35942 2.98587 2.37824 2.90198 2.41467C2.81808 2.4511 2.74256 2.50438 2.68009 2.57119C2.61762 2.638 2.56954 2.71692 2.53882 2.80308C2.50809 2.88923 2.49539 2.98077 2.50149 3.07203C2.65816 5.25365 3.52401 7.32417 4.967 8.96789C6.41 10.6116 8.35095 11.7383 10.4939 12.1762V20.973C10.494 21.1 10.5302 21.2243 10.5983 21.3314C10.6665 21.4385 10.7637 21.524 10.8787 21.5778C10.9936 21.6317 11.1216 21.6516 11.2475 21.6354C11.3734 21.6192 11.4921 21.5674 11.5896 21.4861L14.2621 19.2591C14.3374 19.1965 14.398 19.1181 14.4396 19.0294C14.4812 18.9407 14.5027 18.8439 14.5026 18.746V12.1762C16.6463 11.7391 18.5881 10.6128 20.0318 8.96896C21.4755 7.32516 22.3418 5.25419 22.4986 3.07203V3.07203Z"
      stroke="#9DA6B6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// TODO: Look into this It's not showing up on websites page
export const NotificationIndicator = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
    >
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C20.03248498 36.04202376 38.06282839 72.08511812 56.09034603 108.12962672 C58.22419651 112.39607716 60.35806452 116.66251883 62.49194336 120.92895508 C62.91671586 121.77823776 63.34148835 122.62752045 63.77913275 123.50253897 C70.6347978 137.20953134 77.49187823 150.91581517 84.34949259 164.62183238 C91.39893071 178.71131918 98.44682269 192.80157862 105.49331397 206.89253944 C109.83276735 215.57008192 114.17339037 224.24703719 118.51556691 232.92321735 C121.50302154 238.89279373 124.48895863 244.86312765 127.47376499 250.83402861 C129.18951541 254.26616273 130.90587364 257.69798879 132.62405586 261.12890625 C138.65617679 273.17494892 144.66973112 285.22598444 150.44779968 297.39659119 C156.82037482 310.81609583 163.48082831 324.09041376 170.13509274 337.37159204 C171.99620943 341.0873377 173.85491685 344.80428837 175.71392822 348.52108765 C178.92368349 354.93773623 182.13485227 361.3536757 185.34698486 367.76913452 C190.0033458 377.06918649 194.65703343 386.37057427 199.31003737 395.67230618 C206.87910569 410.803404 214.44966924 425.93375312 222.02148438 441.06347656 C222.47293312 441.96554624 222.92438186 442.86761591 223.38951087 443.79702103 C226.59296691 450.19803421 229.79647714 456.59902026 233 463 C236.65954262 470.31215576 240.31906068 477.6243238 243.97851562 484.93652344 C244.42940355 485.83747116 244.88029148 486.73841889 245.34484267 487.66666806 C252.89177804 502.74680183 260.43711102 517.82773682 267.98132515 532.90923214 C272.61681351 542.17575796 277.2537107 551.44157611 281.89250517 560.70644736 C285.07510416 567.06314994 288.25623947 573.42058362 291.43627787 579.77856755 C293.26347249 583.4316268 295.0912969 587.08436694 296.9209671 590.73618698 C303.66321449 604.19390572 310.35777458 617.66674454 316.81268692 631.2654705 C322.74330205 643.72107814 328.95569275 656.03819082 335.13509274 668.37159204 C336.99620943 672.0873377 338.85491685 675.80428837 340.71392822 679.52108765 C343.92368349 685.93773623 347.13485227 692.3536757 350.34698486 698.76913452 C355.0033458 708.06918649 359.65703343 717.37057427 364.31003737 726.67230618 C371.87910569 741.803404 379.44966924 756.93375312 387.02148438 772.06347656 C387.47293312 772.96554624 387.92438186 773.86761591 388.38951087 774.79702103 C391.59296691 781.19803421 394.79647714 787.59902026 398 794 C401.65954262 801.31215576 405.31906068 808.6243238 408.97851562 815.93652344 C409.42940355 816.83747116 409.88029148 817.73841889 410.34484267 818.66666806 C417.89177804 833.74680183 425.43711102 848.82773682 432.98132515 863.90923214 C437.61681351 873.17575796 442.2537107 882.44157611 446.89250517 891.70644736 C450.07510416 898.06314994 453.25623947 904.42058362 456.43627787 910.77856755 C458.26347249 914.4316268 460.0912969 918.08436694 461.9209671 921.73618698 C468.84899297 935.56470473 475.75023413 949.40100228 482.36438942 963.38350964 C486.49413445 972.1078597 490.85540374 980.71201289 495.2565918 989.30200195 C496 991 496 991 496 993 C169.3 993 -157.4 993 -494 993 C-492.46046476 988.38139428 -490.87146978 984.52054684 -488.69140625 980.22265625 C-488.36518784 979.57542099 -488.03896942 978.92818573 -487.7028656 978.26133728 C-486.65990664 976.19309611 -485.61167849 974.12759213 -484.5625 972.0625 C-480.44526348 963.9428662 -476.36635551 955.8113537 -472.46841621 947.5836668 C-465.47418208 932.82839043 -458.17902118 918.2265731 -450.86490726 903.62840796 C-449.00379057 899.9126623 -447.14508315 896.19571163 -445.28607178 892.47891235 C-442.07631651 886.06226377 -438.86514773 879.6463243 -435.65301514 873.23086548 C-430.9966542 863.93081351 -426.34296657 854.62942573 -421.68996263 845.32769382 C-414.12089431 830.196596 -406.55033076 815.06624688 -398.97851562 799.93652344 C-398.52706688 799.03445376 -398.07561814 798.13238409 -397.61048913 797.20297897 C-393.94872331 789.88619016 -390.28688417 782.56943804 -386.62504196 775.25268745 C-383.4238218 768.85630099 -380.22263096 762.45989985 -377.02148438 756.06347656 C-376.57059645 755.16252884 -376.11970852 754.26158111 -375.65515733 753.33333194 C-368.10822196 738.25319817 -360.56288898 723.17226318 -353.01867485 708.09076786 C-348.38318649 698.82424204 -343.7462893 689.55842389 -339.10749483 680.29355264 C-335.92489584 673.93685006 -332.74376053 667.57941638 -329.56372213 661.22143245 C-327.73652751 657.5683732 -325.9087031 653.91563306 -324.0790329 650.26381302 C-317.794374 637.71945399 -311.51683895 625.17582573 -305.5 612.5 C-299.14620678 599.11430423 -292.50188041 585.87507475 -285.86490726 572.62840796 C-284.00379057 568.9126623 -282.14508315 565.19571163 -280.28607178 561.47891235 C-277.07631651 555.06226377 -273.86514773 548.6463243 -270.65301514 542.23086548 C-265.9966542 532.93081351 -261.34296657 523.62942573 -256.68996263 514.32769382 C-249.12089431 499.196596 -241.55033076 484.06624688 -233.97851562 468.93652344 C-233.52706688 468.03445376 -233.07561814 467.13238409 -232.61048913 466.20297897 C-228.94872331 458.88619016 -225.28688417 451.56943804 -221.62504196 444.25268745 C-218.4238218 437.85630099 -215.22263096 431.45989985 -212.02148438 425.06347656 C-211.57059645 424.16252884 -211.11970852 423.26158111 -210.65515733 422.33333194 C-203.10822196 407.25319817 -195.56288898 392.17226318 -188.01867485 377.09076786 C-183.38318649 367.82424204 -178.7462893 358.55842389 -174.10749483 349.29355264 C-170.92489584 342.93685006 -167.74376053 336.57941638 -164.56372213 330.22143245 C-162.73652751 326.5683732 -160.9087031 322.91563306 -159.0790329 319.26381302 C-151.68546297 304.50604057 -144.36019869 289.72310616 -137.29072571 274.80630493 C-133.90545165 267.6715667 -130.36313017 260.61596167 -126.8125 253.5625 C-126.15930489 252.26116824 -125.5063111 250.95973541 -124.85351562 249.65820312 C-123.60347561 247.16612135 -122.35219917 244.67466848 -121.10034943 242.18349457 C-119.21273542 238.42530455 -117.33027411 234.66455242 -115.45019531 230.90258789 C-114.74237972 229.4866262 -114.03455986 228.07066665 -113.32673645 226.65470886 C-112.95050959 225.90203421 -112.57428272 225.14935955 -112.18665504 224.37387657 C-110.06609096 220.1317361 -107.94499171 215.88986321 -105.82397461 211.64794922 C-104.86945873 209.73892328 -103.91494526 207.82989615 -102.96043396 205.92086792 C-51.48021698 102.96043396 -51.48021698 102.96043396 0 0 Z M0 238 C-21.78 281.56 -43.56 325.12 -66 370 C-63.44829841 371.2758508 -62.6666569 370.82193823 -59.95703125 370.07421875 C-59.13799316 369.85540039 -58.31895508 369.63658203 -57.47509766 369.41113281 C-56.59644043 369.17233398 -55.7177832 368.93353516 -54.8125 368.6875 C-46.21197837 366.44709254 -37.86141992 364.85053807 -29 364 C-27.865625 363.88914062 -26.73125 363.77828125 -25.5625 363.6640625 C6.50962985 360.96708794 37.91697931 365.3518664 69 373 C62.04606602 358.0884502 54.74708436 343.35846043 47.3755672 328.64974046 C45.77259089 325.45014836 44.17196401 322.24938124 42.57106018 319.04875183 C39.55553472 313.02077755 36.53797639 306.99382345 33.51963812 300.9672572 C30.07652279 294.09230335 26.63574867 287.21617869 23.19514549 280.33996737 C16.13265352 266.2253645 9.06730491 252.11219366 2 238 C1.34 238 0.68 238 0 238 Z M-50.64794922 467.48339844 C-68.19519449 487.16622394 -72 512.59266648 -72 538 C-97.41 538 -122.82 538 -149 538 C-157.24221613 553.63431547 -157.24221613 553.63431547 -165.25364685 569.38031006 C-165.80570944 570.48287525 -166.35777204 571.58544045 -166.9265638 572.72141671 C-168.42337602 575.71179938 -169.91845079 578.70303778 -171.41271031 581.69469595 C-173.03844023 584.9484549 -174.66650808 588.20104389 -176.29425049 591.45379639 C-179.46928729 597.79946024 -182.64219638 604.14618555 -185.81430321 610.49331447 C-188.39716274 615.6613073 -190.98081779 620.8289017 -193.56501961 625.99622345 C-193.93516252 626.73635605 -194.30530544 627.47648865 -194.68666481 628.23904951 C-195.43901966 629.74343943 -196.19137628 631.24782845 -196.94373465 632.75221661 C-203.97304052 646.8079874 -210.9999091 660.86497552 -218.02592237 674.9223924 C-224.02912723 686.93326554 -230.03442476 698.9430904 -236.04125977 710.95214844 C-243.04649906 724.95725087 -250.05041476 738.96301394 -257.05228096 752.96980309 C-257.8019072 754.46937405 -258.55153508 755.96894419 -259.30116463 757.46851349 C-259.6698218 758.20598212 -260.03847898 758.94345074 -260.41830758 759.7032669 C-262.99186051 764.85122906 -265.56632959 769.9987324 -268.14117241 775.1460495 C-271.28886521 781.43860279 -274.43508664 787.73188928 -277.57953864 794.0260627 C-279.17791688 797.22541111 -280.77687871 800.42446363 -282.37764168 803.62261963 C-288.80745212 816.46978447 -295.17968611 829.33815609 -301.33543628 842.31932807 C-306.02577903 852.20823605 -310.96549249 861.97000101 -315.91381836 871.73168945 C-317.09569169 874.06551824 -318.27274762 876.4017258 -319.44921875 878.73828125 C-319.80843918 879.44326248 -320.16765961 880.14824371 -320.5377655 880.87458801 C-322.37720624 884.26846766 -322.37720624 884.26846766 -323 888 C-109.16 888 104.68 888 325 888 C323.48868389 883.46605166 321.9516001 879.66403696 319.82641602 875.44165039 C319.51217178 874.81447617 319.19792755 874.18730194 318.87416077 873.54112244 C317.8377486 871.47476621 316.79576963 869.41126852 315.75390625 867.34765625 C315.02041499 865.8869618 314.2873449 864.42605579 313.55467224 862.96495056 C311.62075182 859.11039983 309.68241127 855.25809095 307.74273682 851.40643311 C304.67073265 845.30547763 301.60379948 839.20198158 298.53996086 833.09692192 C297.48827321 831.00344888 296.43372036 828.91144045 295.37879944 826.81959534 C291.95345266 820.00998566 288.59304352 813.17449006 285.32297021 806.2888003 C279.01899237 793.01762915 272.49870225 779.86108079 265.91918945 766.72485352 C264.75484795 764.39645349 263.59068403 762.06796466 262.42668152 759.73939514 C259.94704294 754.77960006 257.46597061 749.82052453 254.98385048 744.8619709 C251.39536583 737.6932175 247.80915824 730.52332683 244.22346058 723.35317909 C238.4022528 711.71293843 232.57926868 700.07358737 226.75512695 688.43481445 C221.10606341 677.14590229 215.4578617 665.85655959 209.81079102 654.56665039 C209.28642774 653.51831792 209.28642774 653.51831792 208.75147126 652.44880701 C206.99731397 648.94179772 205.24317334 645.43478009 203.48904097 641.92775834 C188.99527384 612.95054793 174.4986069 583.97478917 160 555 C156.64949558 558.07594023 155.22189783 561.70861116 153.4375 565.8125 C147.67602644 578.5142687 139.62728686 588.94989311 130 599 C128.824375 600.28777344 128.824375 600.28777344 127.625 601.6015625 C120.33079554 609.31829709 112.10738097 615.20795636 103.44091797 621.27783203 C66.69717357 646.632429 66.69717357 646.632429 44 684 C43.68160156 684.95003906 43.36320312 685.90007812 43.03515625 686.87890625 C39.49368438 699.91870359 41 712.10617657 41 726 C8.99 726 -23.02 726 -56 726 C-54.63253067 669.93375738 -48.49363432 631.75127278 -9 593 C-5.4617824 589.81560416 -1.78302071 586.88676787 2 584 C4.29647633 582.21446549 6.58575803 580.41979578 8.875 578.625 C9.4623291 578.16609375 10.0496582 577.7071875 10.65478516 577.234375 C15.91452006 573.10841478 21.03740357 568.83511416 26.10546875 564.4765625 C27.79583103 563.03028762 29.50053547 561.59992104 31.23828125 560.2109375 C43.44342169 550.2805026 52.8734422 535.69366687 55 520 C56.42155883 499.5295529 54.67963722 479.54863591 41.3125 463.0625 C31.65111621 453.00792036 18.29014465 448.16185558 4.5859375 447.796875 C-17.11020201 447.51961361 -35.32939179 451.18842303 -50.64794922 467.48339844 Z "
        fill="#FF7500"
        transform="translate(494,0)"
      />
      <path
        d="M0 0 C37.29 0 74.58 0 113 0 C113 36.63 113 73.26 113 111 C75.71 111 38.42 111 0 111 C0 74.37 0 37.74 0 0 Z "
        fill="#FF7603"
        transform="translate(428,764)"
      />
      <path
        d="M0 0 C0.75345703 0.36109863 1.50691406 0.72219727 2.28320312 1.09423828 C34.40367087 16.64858191 59.98063195 43.22353861 72 77 C72.35457275 77.98830811 72.35457275 77.98830811 72.71630859 78.99658203 C84.59755197 112.98669442 80.2410163 152.7008903 65.19140625 184.95703125 C53.86803703 208.04031891 35.31207674 226.00309519 14.34423828 240.37451172 C-11.09178762 258.01178108 -37.48135849 276.53978779 -45.75 308 C-47.60613724 319.87927837 -47.57086593 331.98424601 -48 344 C-80.01 344 -112.02 344 -145 344 C-145 288.49857029 -138.95756721 251.50771934 -100.78759766 212.75585938 C-93.69758538 205.79172822 -85.79341934 199.77415379 -77.88793945 193.77709961 C-72.72644456 189.84412323 -67.77992019 185.67847923 -62.86328125 181.4453125 C-61.26081966 180.07677095 -59.64405813 178.72323282 -57.98046875 177.4296875 C-46.01739178 168.07215188 -37.03223328 152.99756655 -35 138 C-33.5981353 117.81314836 -35.27597577 98.00969835 -48.1875 81.5625 C-57.57190187 71.73523871 -71.12176793 67.15088522 -84.4140625 66.796875 C-104.40533578 66.5414006 -121.7881592 69.25990152 -136.79931641 83.4699707 C-156.35785215 103.20343091 -158.69160473 129.45345444 -161 156 C-195.98 156 -230.96 156 -267 156 C-265.82157955 132.43159108 -265.82157955 132.43159108 -264.3125 123.0625 C-264.13807373 121.97042236 -263.96364746 120.87834473 -263.78393555 119.75317383 C-256.63290829 77.30727081 -234.37761467 37.17367098 -199.0625 11.8125 C-196.72665629 10.18027743 -194.3690071 8.58360412 -192 7 C-190.96230469 6.30003906 -189.92460937 5.60007812 -188.85546875 4.87890625 C-134.52694582 -30.17836703 -56.67634347 -27.5046961 0 0 Z M-139 -12 C-140.38889042 -11.68299493 -141.77819782 -11.36780977 -143.16796875 -11.0546875 C-175.65017978 -3.17419186 -206.78650933 16.31819232 -227 43 C-227.4007373 43.52577637 -227.80147461 44.05155273 -228.21435547 44.59326172 C-239.54464567 59.56906506 -247.58031818 75.3686629 -254 93 C-254.26449951 93.72106934 -254.52899902 94.44213867 -254.80151367 95.18505859 C-256.93661129 101.26528232 -258.3094462 107.43504178 -259.5625 113.75 C-259.77865967 114.83313477 -259.99481934 115.91626953 -260.2175293 117.03222656 C-262.49529708 128.89498672 -264 140.90869079 -264 153 C-231 153 -198 153 -164 153 C-163.67 147.39 -163.34 141.78 -163 136 C-162.5012058 132.53044625 -161.98512239 129.21865168 -161.25 125.8125 C-161.0744458 124.9771875 -160.8988916 124.141875 -160.71801758 123.28125 C-156.20970179 102.73043283 -146.57118569 84.14085798 -128.51953125 72.45703125 C-111.35396935 62.53027995 -91.17730567 59.87885694 -71.875 64.625 C-56.14408162 69.57989279 -45.36865228 76.90233323 -37.66015625 91.59375 C-32.30085192 102.58978148 -31.79915304 113.07741876 -31.75 125.1875 C-31.7190625 127.06405273 -31.7190625 127.06405273 -31.6875 128.97851562 C-31.60201759 149.50497957 -39.83974979 164.71348005 -54 179 C-57.52981669 182.1945827 -61.22996888 185.09670382 -65 188 C-66.94371902 189.61755607 -68.88102678 191.24284117 -70.8125 192.875 C-74.54309162 195.998286 -78.3143049 199.0377234 -82.16748047 202.0078125 C-110.4521698 223.85529667 -134.26449638 253.69370521 -140 290 C-140.18433594 291.12921875 -140.36867188 292.2584375 -140.55859375 293.421875 C-142.71059588 309.15375266 -142 323.73772136 -142 340 C-111.97 340 -81.94 340 -51 340 C-50.67 330.43 -50.34 320.86 -50 311 C-48.89794116 305.61686643 -48.07456244 301.83430145 -46 297 C-45.29037109 295.27910156 -45.29037109 295.27910156 -44.56640625 293.5234375 C-40.40583779 284.36420045 -34.80397775 277.30752562 -28 270 C-26.84564453 268.72382812 -26.84564453 268.72382812 -25.66796875 267.421875 C-15.70503756 256.89884717 -3.46432585 248.74422636 8.25 240.3125 C10.48785248 238.69899836 12.72538082 237.08505641 14.96191406 235.46972656 C16.23787969 234.54958843 17.51560061 233.63187406 18.79589844 232.71777344 C37.940922 218.98500874 52.75276785 201.91563145 63.11376953 180.80419922 C63.94036061 179.12141462 64.79530245 177.45263849 65.65234375 175.78515625 C79.87225948 145.93418811 79.57732996 106.95694204 68.79052734 76.07177734 C58.41607733 48.88290063 38.62993088 26.14623406 14 11 C13.35981934 10.60087402 12.71963867 10.20174805 12.06005859 9.79052734 C1.26405087 3.13860788 -10.12583159 -1.61730473 -22 -6 C-23.13695312 -6.4228125 -24.27390625 -6.845625 -25.4453125 -7.28125 C-32.8243586 -9.87867423 -40.30107698 -11.65136107 -48 -13 C-48.74475586 -13.13825195 -49.48951172 -13.27650391 -50.25683594 -13.41894531 C-78.56845981 -18.47418488 -111.03818039 -19.0854043 -139 -12 Z "
        fill="#FFF7F0"
        transform="translate(583,382)"
      />
      <path
        d="M0 0 C37.29 0 74.58 0 113 0 C113 36.63 113 73.26 113 111 C75.71 111 38.42 111 0 111 C0 74.37 0 37.74 0 0 Z M3 3 C3 37.65 3 72.3 3 108 C38.31 108 73.62 108 110 108 C110 73.35 110 38.7 110 3 C74.69 3 39.38 3 3 3 Z "
        fill="#FFFFFF"
        transform="translate(428,764)"
      />
      <path
        d="M0 0 C0.66 0.33 1.32 0.66 2 1 C1.62956667 2.94251626 1.22763135 4.87904293 0.8125 6.8125 C0.59207031 7.89144531 0.37164063 8.97039063 0.14453125 10.08203125 C-1.2421505 13.61735982 -2.62212068 14.42439344 -6 16 C-5.79503906 15.25234375 -5.59007812 14.5046875 -5.37890625 13.734375 C-5.10949219 12.74953125 -4.84007812 11.7646875 -4.5625 10.75 C-4.29566406 9.77546875 -4.02882813 8.8009375 -3.75390625 7.796875 C-3.2993692 6.11061321 -2.87935604 4.41373018 -2.52734375 2.703125 C-2.35332031 2.14109375 -2.17929687 1.5790625 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z "
        fill="#FFEDDF"
        transform="translate(656,537)"
      />
    </svg>
  );
};

export const InsyncLightBgIcon = (props) => (
  <svg
    preserveAspectRatio="none"
    viewBox="0 0 688 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="183.849"
      y="0.416504"
      width="504.152"
      height="165.27"
      fill="url(#pattern0_3_4357)"
    />
    <path
      d="M130.673 98.512L121.512 114.068C119.85 116.887 117.48 119.223 114.637 120.846C111.795 122.468 108.578 123.32 105.305 123.317H39.4872C36.1861 123.319 32.9427 122.451 30.0837 120.801C27.2247 119.15 24.851 116.776 23.2017 113.916L14.3147 98.512H130.673Z"
      fill="#173DAA"
    />
    <path
      d="M130.673 98.512L122.736 111.972C122.067 113.14 121.101 114.111 119.937 114.786C118.772 115.461 117.45 115.816 116.104 115.816C114.758 115.816 113.435 115.461 112.271 114.786C111.106 114.111 110.141 113.14 109.472 111.972L101.745 98.512H130.673Z"
      fill="#377BF6"
    />
    <path
      d="M151.278 63.5071L130.674 98.4383H43.0276L72.2054 48.3037H142.611C144.39 48.2992 146.139 48.7667 147.678 49.6585C149.218 50.5503 150.493 51.8346 151.374 53.3803C152.255 54.9259 152.711 56.6777 152.694 58.4567C152.677 60.2358 152.188 61.9785 151.278 63.5071Z"
      fill="#377BF6"
    />
    <path
      d="M1.50062 61.4656L22.8393 25.2321H110.27L86.0913 67.1014C84.6411 69.6083 82.5561 71.6889 80.0461 73.1339C77.5362 74.5788 74.6899 75.3371 71.7937 75.3323H9.43773C7.81733 75.3292 6.22641 74.8988 4.8254 74.0847C3.42439 73.2705 2.26283 72.1013 1.45787 70.695C0.652911 69.2887 0.233011 67.6949 0.240516 66.0746C0.248022 64.4542 0.682667 62.8644 1.50062 61.4656Z"
      fill="#ED772F"
    />
    <path
      d="M22.8389 25.2267L32.6073 8.6572C34.0859 6.1475 36.1939 4.06717 38.7229 2.62189C41.2519 1.17661 44.1144 0.416433 47.0272 0.41651H114.931C117.87 0.414085 120.757 1.1869 123.302 2.65697C125.846 4.12704 127.958 6.24234 129.424 8.7894L138.899 25.2267H22.8389Z"
      fill="#ED772F"
    />
    <path
      d="M138.9 25.2276H110.27L118.795 10.46C119.38 9.44187 120.224 8.59607 121.24 8.00793C122.257 7.41979 123.411 7.11011 124.585 7.11011C125.759 7.11011 126.913 7.41979 127.93 8.00793C128.946 8.59607 129.79 9.44187 130.375 10.46L138.9 25.2276Z"
      fill="#F09A35"
    />
    <defs>
      <pattern
        id="pattern0_3_4357"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          href="#image0_3_4357"
          transform="translate(-0.352249) scale(0.00682954 0.0208333)"
        />
      </pattern>
      <image
        id="image0_3_4357"
        width="198"
        height="48"
        preserveAspectRatio="none"
        href="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
